import { ActivatedRoute, Router } from "@angular/router";
import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { Subject, Subscription } from "rxjs";

import { AppMemoryService } from "../../core/app-memory.service";
import { DatePipe } from "@angular/common";
import { GetService } from "../../core/get.service";
import { Horse } from "../../core/classes/horse";
import { Note } from "../../core/classes/note";
import { DownloadPresignedUrls } from "../../core/classes/storage";
import { NotificationsService } from "angular2-notifications";
import {
  Administer,
  Treatment,
  TreatmentAdminister,
} from "../../core/classes/treatment";
import { Vaccination } from "app/core/classes/vaccination";
import { environment } from "../../../environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { TooltipComponent } from "../../core/tooltip/tooltip.component";
import { NoteInfo } from "../../core/classes/note-info";
import { RouteTypes } from "../../core/types/route-types";
import { UKRegions, usaRegionBC2023 } from "app/models/Regions";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { usaRegionPC, usaRegionPK } from "../../models/Regions";
import { NoteType } from "../../core/types/note-type";
import { DateObjPipe } from "app/core/pipes/date-obj.pipe";
import { AppStorageType } from "app/models/AppStorageType";
import { HttpClient } from "@angular/common/http";
import {
  AUSIntraArticularAdditionalInfo,
  IntraArticularAdditionalInfoA,
  IntraArticularAdditionalInfoB,
} from "app/core/types/intra-articular-info-types";
import {
  AUSTreatmentTypes,
  FrequencyType,
} from "app/core/types/aus-form-types";

declare const ImageCompressor: any;

enum TreatmentSaveType {
  Save = 1,
  SaveAndCopy = 2,
}

@Component({
  selector: "app-horse",
  templateUrl: "./horse.component.html",
  styleUrls: ["./horse.component.less"],
})
export class HorseComponent implements OnInit {
  UKRegions = UKRegions;

  @HostListener("document:scroll", ["$event"])
  onWindowScroll() {
    if (this.tabs.isNotes) {
      if (
        $(window).scrollTop() >=
        $(document).height() - $(window).height() - 100
      ) {
        this.addNewData(this.notes);
      }
    }

    if (this.tabs.isVaccinations) {
      if (
        $(window).scrollTop() >=
        $(document).height() - $(window).height() - 100
      ) {
        this.addNewData(this.vaccinations);
      }
    }
  }

  @ViewChild("imageLoader") public imageLoader: any;
  @ViewChild("imageLoader2") public imageLoader2: any;
  @ViewChild("imageLoader22") public imageLoader22: any;
  @ViewChild("imageLoader23") public imageLoader23: any;
  @ViewChild("imageLoader24") public imageLoader24: any;

  @ViewChild("farmsSelector") public farmsSelector: any;

  @ViewChild("measuresSelector") public measuresSelector: any;

  @ViewChild("updateHorseForm") public updateHorseForm: any;

  @ViewChild("createHorseForm") public createHorseForm: any;

  @ViewChild("createTreatmentForm") public createTreatmentForm: any;

  @ViewChild("updateTreatmentForm") public updateTreatmentForm: any;

  @ViewChild("weightsSelector") public weightsSelector: any;

  @ViewChild("noteDescr") public noteDescr: any;

  public usVaccinationPeriod = "365 days";
  public europeVaccinationPeriod = "6 months";

  public maxImgCount = environment.maxImgCount;
  public maxImgSize = environment.maxImgSize;
  public showInTheFoodChainToggle = environment.showInTheFoodChainToggle;

  public drugs: any;
  public longActingDrugs: Drug[];
  public routineDrugs: Drug[];
  public drugList: Drug[]; // final list of drugs based on the type

  public selectedTab?: string;
  public selectedTreatmentType: string;
  public selectedNoteType: string;

  public treatmentTypes: TreatmentTab[] = [];
  public hkTreatmentTypes: TreatmentTab[] = [];
  public hkDeclarationTypes: TreatmentTab[] = [];
  public hkVeterinaryTypes: TreatmentTab[] = [];
  public noteTypes: NoteTab[] = [];
  public ausTreatmentTypes: TreatmentTab[] = [];
  public ausNoteTypes: NoteTab[] = [];
  public ausTreatmentProcedures = [];

  public ausPreTravelTreatmentTypes: TreatmentTab[] = [];
  public ausPreTravelNoteTypes: NoteTab[] = [];
  public hongkongHealthCertificate: TreatmentTab[] = [];

  public objectKeys = Object.keys;

  public horse: Horse;
  public horseId: number;
  public regionId: string = "";

  public newHorse = new Horse();

  public newTreatment = new Treatment();

  public treatments: Treatments;
  public treatmentsByDate = [] as any;
  public treatmentsByDateArchive = [] as any;
  public aintreeTabs = [] as any;
  public hongkongTabs = [] as any;
  public ausTabs = [] as any;
  public ausPreTravelTabs = [] as any;

  public currentTreatment: Treatment;
  public currentNote: Note;
  public currentVaccination: Vaccination;

  public _searchStream = new Subject<any>();

  public translation = {};

  public hideAddBtn: boolean = false;
  public tabs = {
    isTreatments: true as boolean,
    isNotes: false as boolean,
    isVaccinations: false as boolean,
    isHorse: false as boolean,
    isNormalTreatment: true as boolean,
    isQuickTreatment: false as boolean,
    displayAintreeTabs: true as boolean,
    isPreTravelTab: false as boolean,
    isPreRaceTab: false as boolean,
  };

  public vaccinationCountries = [].concat(
    [environment.currentCountry],
    environment.vaccinationCountries
  );
  public currentCountry = environment.currentCountry;
  public isUkCountry = this.currentCountry.toLowerCase() === "uk";
  public isIECountry = this.currentCountry.toLowerCase() === "ie";
  public isUSCountry = this.currentCountry.toLowerCase() === "us";
  public isHKCountry = this.currentCountry.toLowerCase() === "hk";
  public isAUSCountry = this.currentCountry.toLowerCase() === "aus";

  public quick_treatment = environment.quick_treatment;

  public newNote = new Note();
  public newVaccination = new Vaccination();

  public farms: Farms | any;

  public notes;

  public aintreeNoteTypes: NoteTab[];
  public noteTypesList = [];
  public extraAintreeTabs = [];
  public vaccinationNumbers = ["primary", "secondary", "booster"];

  public routeTypes = [
    RouteTypes.intraVenous,
    RouteTypes.intraMuscular,
    RouteTypes.intraArticular,
    RouteTypes.oral,
    RouteTypes.other,
  ];

  public intraArticularAdditionalInfosA = [
    IntraArticularAdditionalInfoA.left_Fore,
    IntraArticularAdditionalInfoA.right_fore,
    IntraArticularAdditionalInfoA.left_hind,
    IntraArticularAdditionalInfoA.right_hind,
  ];

  public intraArticularAdditionalInfosB = [
    IntraArticularAdditionalInfoB.fetlock,
    IntraArticularAdditionalInfoB.carpus,
    IntraArticularAdditionalInfoB.hock,
    IntraArticularAdditionalInfoB.stifle,
    IntraArticularAdditionalInfoB.other,
  ];

  public ausIntraArticularAdditionalInfo = [
    AUSIntraArticularAdditionalInfo.limb,
    AUSIntraArticularAdditionalInfo.joint,
  ];

  public serverError = null;
  public serverErrorValidate = null;
  public isRequestInProgress = false;
  public isRequestInProgress2 = false;
  public isRequestInProgress3 = false;
  public isRequestInProgress4 = false;
  public isRequestInProgress5 = false;
  public isRequestSuccess = false;

  public isMicrochipChanged = false;
  public isImagesChanged = false;

  public invalidVaccinationForm = false;
  public invalidTreatmentForm = false;

  public dateRangeErrorMessage: {
    from?: string;
    due?: string;
    date?: string;
  } = {} as { from?: string; due?: string; date?: string };
  public dateRangeTreatmentErrorMessage: {
    from?: string;
    due?: string;
    date?: string;
  } = {} as { from?: string; due?: string; date?: string };
  public dateRangeEditTreatmentErrorMessage: {
    from?: string;
    due?: string;
    date?: string;
  } = {} as { from?: string; due?: string; date?: string };

  public datePicker = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 40)),
    maxDate: new Date() as Date,
    currentDate: new Date() as Date,
    currentDate_input:
      "" /*this.datePipe.transform(new Date(), environment.dateFormat)*/,
    isActive: false as boolean,
  };

  public datePicker2 = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 40)),
    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 40)),
    currentDate: new Date(new Date().setDate(new Date().getDate())),
    currentDate_input:
      "" /*this.datePipe.transform(new Date(), environment.dateFormat)*/,
    isActive: false as boolean,
  };

  public datePicker3 = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 3)),
    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 3)),
    currentDate: new Date() as Date,
    currentDate_input:
      /*this.datePipe.transform(new Date(), environment.dateFormat)*/ "",
    isActive: false as boolean,
  };

  public datePicker4 = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 40)),
    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 40)),
    currentDate: new Date(new Date().setDate(new Date().getDate())),
    currentDate_input:
      /*this.datePipe.transform(new Date(), environment.dateFormat)*/ "",
    isActive: false as boolean,
  };

  public datePicker5 = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 3)),
    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 3)),
    currentDate: new Date() as Date,
    currentDate_input:
      "" /*this.datePipe.transform(new Date(), environment.dateFormat)*/,
    isActive: false as boolean,
  };

  public datePickerAddNote = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 3)),
    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 3)),
    currentDate: new Date() as Date,
    currentDate_input: this.datePipe.transform(
      new Date(),
      environment.dateFormat
    ),
    isActive: false as boolean,
  };

  public loadSuggestion: boolean;

  public farmSelectModel: Array<Object> = [
    {
      id: null as number,
      text: "" as string,
    },
  ];

  public measuresSelectorModel: any;
  public weightsSelectorModel: any;
  public frequencySelectorModel: any;
  public drugTypesSelectorModel: any;

  public farmSelectModelLoaded = false;

  public treatmentStatus = {
    request_id: null as number,
    status: "" as string,
    comment: "" as string,
    vetclinic_id: 1 as number, // TO DO
  };

  public pagination = {
    inProgress: false as boolean,
    nextPage: "" as string,
  };
  public paginationTr = {
    inProgress: false as boolean,
    nextPage: "" as string,
  };
  public paginationVc = {
    inProgress: false as boolean,
    nextPage: "" as string,
  };

  public administers: Administer[] = [];
  public administer: Administer[] = [];

  public toggleLabel: string = "";
  public vetRoleTabs = [
    "veterinary_inspection_form",
    "veterinary_declaration_execution_submission_form",
    "pre_travel_veterinary_inspection_form",
    "pre_travel_veterinary_declaration_execution_submission_form",
  ];

  public isFormInViewMode: boolean = false;

  public showOtherSubstancesInput: boolean = undefined;

  public newMedication: string = "";

  processServerError(err?: any): string {
    const error = err || {};

    try {
      return !err._body
        ? err.message
        : Object.keys((err._body = JSON.parse(err._body)))
            .reduce((acc, key) => acc.concat(err._body[key]), [])
            .toString();
    } catch (e) {
      // tslint:disable-next-line:one-line
      return "";
    }
  }

  public hasNoTreatment = false;

  public setHasNoTreatment(e: Event) {
    this.hasNoTreatment = !this.hasNoTreatment;
    delete this.newTreatment.route;
    if (this.hasNoTreatment) {
      this.newTreatment.route = RouteTypes.noTreatment;
    }
  }

  public getPresignedUrl(imagePath: string) {
    if (this.appMemory.static.appStorageType == AppStorageType.fileSystem) {
      window.open(imagePath, "_blank");
    } else {
      if (imagePath) {
        var assetPaths: DownloadPresignedUrls[] = [
          { path: imagePath, url: null },
        ];
        this.getService.getPresignedUrl(assetPaths).then(
          (res: DownloadPresignedUrls[]) => {
            window.open(res[0].url, "_blank");
          },
          (err: any) => {}
        );
      }
    }
  }

  public getPresignedUrls(assets: string[], entity: string) {
    if (assets && assets.length > 0) {
      var assetPaths: DownloadPresignedUrls[] = assets.map((asset) => ({
        path: asset,
        url: null,
      }));

      this.getService
        .getPresignedUrl(assetPaths)
        .then((res: DownloadPresignedUrls[]) => {
          if (entity == "treatments") {
            if (res) {
              this.newTreatment.srcs = this.newTreatment.srcs.map(
                (item, index) => ({
                  ...item,
                  src: res[index].url,
                  iconsrc: res[index].url,
                })
              );
            }
          }

          if (entity == "notes") {
            if (res) {
              this.newNote.srcs = this.newNote.srcs.map((item, index) => ({
                ...item,
                iconsrc: res[index].url,
                src: res[index].url,
              }));
            }
          }

          if (entity == "horse") {
            if (res) {
              this.horse.microchip = res[0] ? res[0].url : "";
              this.imageLoader.files[0] = new File([""], "microchip");
              this.imageLoader.files[0].src = this.horse.microchip;
              this.imageLoader.fileChange(this.imageLoader.files[0]);
              this.imageLoader.fileCounter = 1;
            }
          }
        });
    }
  }

  public objectToArray(obj: Object) {
    return Object.keys(obj).map((key) => obj[key]); // transorm Array-like Object to Array
  }

  public isUserLoaded = false;
  public isAddTreatment = false;

  public vaccinations: any[];

  public maxLength;
  public isShowTooltip: boolean;
  screenHeight;
  screenWidth;

  public currentFarm: Farm;

  @ViewChild("addVaccinationTutorial") tooltip: TooltipComponent;

  private regionSelected: BehaviorSubject<string | undefined> =
    new BehaviorSubject<string | undefined>(undefined);
  public hasSignNoteType = false;

  public sortTreatmentObj = { field: "treatmentDate", order: "desc" };
  public sortNoteObj = { field: "noteDate", order: "desc" };

  public treatmentSaveType = TreatmentSaveType;
  public triggerButton: number = TreatmentSaveType.Save;

  public frequency_types = [];
  public showEndDateField = true;

  public eligible_forms: any;

  constructor(
    private notificationsService: NotificationsService,
    public appMemory: AppMemoryService,
    public getService: GetService,
    public activatedRoute: ActivatedRoute,
    public datePipe: DatePipe,
    public dateLocalPipe: DateObjPipe,
    public translateService: TranslateService,
    private http: HttpClient
  ) {
    this.noteTypes = [
      {
        type: NoteType.feed,
      },
      {
        type: NoteType.location,
      },
      {
        type: NoteType.training,
      },
      {
        type: NoteType.weight,
      },
      {
        type: NoteType.other,
      },
    ];
  }

  filterDrugs() {
    if (environment.filterRegionForDrugs) {
      if (this.isAUSCountry) {
        this.drugs = [];

        this.longActingDrugs = this.appMemory.static.longActingDrugs.filter(
          (drug: any) =>
            !!drug.region ? drug.region === this.newHorse.farm.region : true
        );
        this.routineDrugs = this.appMemory.static.routineDrugs.filter(
          (drug: any) =>
            !!drug.region ? drug.region === this.newHorse.farm.region : true
        );
      } else {
        this.drugs = this.appMemory.static.drugs.filter((drug: any) =>
          !!drug.region ? drug.region === this.newHorse.farm.region : true
        );
      }
    }

    if (this.isAUSCountry) {
      this.drugs = [];

      if (
        !this.longActingDrugs.includes(this.appMemory.static.longActingDrugs[0])
      ) {
        this.longActingDrugs.unshift(this.appMemory.static.longActingDrugs[0]);
      }
      if (!this.routineDrugs.includes(this.appMemory.static.routineDrugs[0])) {
        this.routineDrugs.unshift(this.appMemory.static.routineDrugs[0]);
      }
    } else {
      if (!this.drugs.includes(this.appMemory.static.drugs[0])) {
        this.drugs.unshift(this.appMemory.static.drugs[0]);
      }
    }

    this.getDrugsList();
  }

  @HostListener("window:resize", ["$event"])
  onResize(event?) {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
  }

  public selectCountryVaccination(country) {
    this.newVaccination.vaccination_countries =
      this.newVaccination.vaccination_countries.includes(country)
        ? this.newVaccination.vaccination_countries.filter(
            (val) => val !== country
          )
        : [].concat(this.newVaccination.vaccination_countries, [country]);
  }

  public calcQuantityMaxLength() {
    return 5;
  }

  public calcMaxLength(value) {
    if (value.toString().split(".")[1]) {
      const tmp = value.toString().split(".")[0].length + 3;

      if (tmp < 5) {
        this.maxLength = 5;
      } else {
        this.maxLength = tmp;
      }
    } else {
      this.maxLength = 5;
    }
    // console.log('THIS.MAXLENGTH', this.maxLength);
  }

  getTooltip() {
    return (this.isShowTooltip = this.appMemory.getTooltip());
  }

  showTooltip(key, localClass) {
    $("body").removeClass("modal-open");
    $("#add-vaccination").removeClass("open");
    // $('#add-vaccination').trigger('click');
    return this.tooltip.showTooltip(key, localClass);
  }

  getTranslation() {
    this.translateService
      .get("OTHER.addedSuccess")
      .subscribe((word: string) => {
        this.translation["addedSuccess"] = word;
      });
    this.translateService
      .get("OTHER.errorOccurred")
      .subscribe((word: string) => {
        this.translation["errorOccurred"] = word;
      });
    this.translateService.get("HORSES.addNote").subscribe((word: string) => {
      this.translation["addNote"] = word;
    });
    this.translateService.get("HORSES.editNote").subscribe((word: string) => {
      this.translation["editNote"] = word;
    });
    this.translateService.get("HORSES.editHorse").subscribe((word: string) => {
      this.translation["editHorse"] = word;
    });
    this.translateService.get("TREATS.addTreat").subscribe((word: string) => {
      this.translation["addTreat"] = word;
    });
    this.translateService
      .get("TREATS.deleteTreat")
      .subscribe((word: string) => {
        this.translation["deleteTreat"] = word;
      });
    this.translateService
      .get("OTHER.edittedSuccess")
      .subscribe((word: string) => {
        this.translation["edittedSuccess"] = word;
      });
    this.translateService.get("TREATS.editTreat").subscribe((word: string) => {
      this.translation["editTreat"] = word;
    });
    this.translateService.get("HORSES.note").subscribe((word: string) => {
      this.translation["note"] = word;
    });
    this.translateService.get("HORSES.horse").subscribe((word: string) => {
      this.translation["horse"] = word;
    });
    this.translateService.get("OTHER.uploadImage").subscribe((word: string) => {
      this.translation["uploadImage"] = word;
    });
    this.translateService.get("TREATS.treatment").subscribe((word: string) => {
      this.translation["treatment"] = word;
    });
    this.translateService
      .get("TREATS.closeTreatment")
      .subscribe((word: string) => {
        this.translation["closeTreatment"] = word;
      });
    this.translateService.get("HORSES.addVacs").subscribe((word: string) => {
      this.translation["addVacs"] = word;
    });
    this.translateService
      .get("OTHER.deletedSuccess")
      .subscribe((word: string) => {
        this.translation["deletedSuccess"] = word;
      });
    this.translateService
      .get("TREATS.treatmentStatus")
      .subscribe((word: string) => {
        this.translation["treatmentStatus"] = word;
      });
    this.translateService
      .get("TREATS.updateTreatmentStatus")
      .subscribe((word: string) => {
        this.translation["updateTreatmentStatus"] = word;
      });
    this.translateService
      .get("TREATS.updatedSuccess")
      .subscribe((word: string) => {
        this.translation["updatedSuccess"] = word;
      });
    this.translateService.get("HORSES.delectVacc").subscribe((word: string) => {
      this.translation["delectVacc"] = word;
    });
    this.translateService.get("HORSES.vacc").subscribe((word: string) => {
      this.translation["vacc"] = word;
    });
    this.translateService
      .get("HORSES.archiveHorse")
      .subscribe((word: string) => {
        this.translation["archiveHorse"] = word;
      });
    this.translateService
      .get("HORSES.wasAlreadyDeleted")
      .subscribe((word: string) => {
        this.translation["wasAlreadyDeleted"] = word;
      });
    this.translateService.get("HORSES.deleteNote").subscribe((word: string) => {
      this.translation["deleteNote"] = word;
    });
    this.translateService
      .get("OTHER.archivedSuccess")
      .subscribe((word: string) => {
        this.translation["archivedSuccess"] = word;
      });
    this.translateService
      .get("OTHER.isNotEligible")
      .subscribe((word: string) => {
        this.translation["isNotEligible"] = word;
      });
    this.translateService
      .get("HORSES.description")
      .subscribe((word: string) => {
        this.translation["description"] = word;
      });
    this.translateService.get("CORE.invalidDate").subscribe((word: string) => {
      this.translation["invalidDate"] = word;
    });
  }

  getHorseByUserRole(
    {
      excludeHorse = false,
      excludeTreatments = false,
      excludeNotes = false,
      excludeVaccination = false,
      excludeAdminister = false,
    } = {} as any
  ) {
    let horseCall;
    let notesCall;
    let vaccinationCall;

    const { roles: [{ id: roleId } = {} as Role] = [] } =
      this.appMemory.user || {};

    switch (roleId) {
      case 1:
        horseCall = this.getHorse.bind(this);
        notesCall = this.getNotes.bind(this, "/instructor");
        vaccinationCall = this.getVaccinations.bind(this);
        break;

      case 2:
        horseCall = this.getHorseA.bind(this);
        notesCall = this.getNotes.bind(this, "/assistant");
        vaccinationCall = this.getVaccinations.bind(this);
        break;

      case 3:
        horseCall = this.getHorseV.bind(this);
        if (
          this.tabs.displayAintreeTabs ||
          this.horse.farm.region == usaRegionBC2023 ||
          this.isHKCountry ||
          this.isAUSCountry
        ) {
          notesCall = this.getNotes.bind(this, "/vet");
        }

        if (!this.isHKCountry) {
          vaccinationCall = this.getVaccinations.bind(this);
        }
        break;
    }

    if (!excludeHorse) {
      horseCall();
    }

    if (!excludeTreatments) {
      this.getHorse("/treatments", this.selectedTab);
      if (!excludeAdminister) {
        this.getTreatmentAdministers();
      }
    }

    if (!excludeNotes && notesCall) {
      notesCall(this.selectedTab);
    }

    if (!excludeVaccination && vaccinationCall) {
      vaccinationCall();
    }
  }

  ngOnInit(): void {
    this.horseId = this.activatedRoute.params["value"]["horse_id"];

    this.tabs.isTreatments = this.isAUSCountry ? false : this.tabs.isTreatments;

    this._searchStream.debounceTime(200).subscribe((res) => {
      if (res && res.length > 0) {
        this.getFarms(res);
      }
    });

    this.appMemory.staticLoaded.subscribe((val) => {
      // tslint:disable-next-line:curly
      if (!val) return;

      this.noteTypesList = this.appMemory.static.notes || [];
      this.drugs = this.appMemory.static.drugs;

      if (!this.isUSCountry) {
        this.noteTypes = this.appMemory.static.notes;
      }
      this.treatmentTypes = this.appMemory.static.treatments;
      this.aintreeNoteTypes = this.appMemory.static.aintreeRegionNotes;
      // uncomment to display Optional Video Submission tab
      // this.extraAintreeTabs = this.appMemory.static.extraAintreeTabs;

      if (this.treatmentTypes && this.aintreeNoteTypes) {
        this.aintreeTabs = this.treatmentTypes
          .concat(this.aintreeNoteTypes)
          .sort(
            (aintreeTab, previousAintreeTab) =>
              aintreeTab.order - previousAintreeTab.order
          );
      }

      if (this.isHKCountry) {
        this.hkTreatmentTypes = this.appMemory.static.hongkongTreatments;
        this.hkDeclarationTypes = this.appMemory.static.hongkongDeclarations;
        this.hkVeterinaryTypes = this.appMemory.static.hongkongVeterinaryForms;
        this.hongkongHealthCertificate =
          this.appMemory.static.hongkongHealthCertificate;

        this.hongkongTabs = this.appMemory.static.hongkongTreatments.concat(
          this.hkDeclarationTypes,
          this.hkVeterinaryTypes,
          this.hongkongHealthCertificate
        );
      }

      if (this.isAUSCountry) {
        this.ausTreatmentProcedures =
          this.appMemory.static.treatment_procedures;
        this.ausTreatmentTypes = this.appMemory.static.ausTreatments;
        this.ausNoteTypes = this.appMemory.static.notes;

        if (this.ausNoteTypes) {
          this.ausTabs = this.appMemory.static.ausTreatments.concat(
            this.ausNoteTypes
          );
        }
        if (
          this.appMemory.static.aus_rv_pre_travel_treatments &&
          this.appMemory.static.aus_rv_pre_travel_notes
        ) {
          this.ausPreTravelTreatmentTypes =
            this.appMemory.static.aus_rv_pre_travel_treatments;
          this.ausPreTravelNoteTypes =
            this.appMemory.static.aus_rv_pre_travel_notes;

          this.ausPreTravelTabs =
            this.appMemory.static.aus_rv_pre_travel_treatments.concat(
              this.appMemory.static.aus_rv_pre_travel_notes
            );
        }

        this.longActingDrugs = this.appMemory.static.longActingDrugs;
        this.routineDrugs = this.appMemory.static.routineDrugs;

        this.frequency_types = this.appMemory.static.frequency_types.map(
          (item) => {
            return {
              id: item,
              text: item,
            };
          }
        );
      }

      this.appMemory.userSubject.subscribe((e) => {
        if (this.appMemory.user && !this.isUserLoaded) {
          this.selectedTreatmentType = this.appMemory.static.treatments
            ? (this.appMemory.static.treatments[0] || ({} as TreatmentTab)).type
            : "";
          this.selectedNoteType = this.appMemory.static.notes
            ? (this.appMemory.static.notes[0] || ({} as NoteTab)).type
            : "";

          this.horseId = this.activatedRoute.params["value"]["horse_id"];
          this.getHorseDetails();

          if (
            this.appMemory.user.roles[0].id == 3 &&
            this.ausTabs &&
            this.ausTabs.length > 0
          ) {
            //vet
            this.ausTabs = this.ausTabs.filter((tab: any) =>
              this.vetRoleTabs.includes(tab.type)
            );
            this.ausPreTravelTabs = this.ausPreTravelTabs.filter((tab: any) =>
              this.vetRoleTabs.includes(tab.type)
            );
            if (this.isAUSCountry) {
              this.ausPreTravelNoteTypes =
                this.appMemory.static.aus_rv_pre_travel_notes.filter(
                  (tab: any) => this.vetRoleTabs.includes(tab.type)
                );
            }

            this.noteTypes = this.appMemory.static.notes.filter((tab: any) =>
              this.vetRoleTabs.includes(tab.type)
            );
          } else {
            this.ausTabs = this.ausTabs.filter(
              (tab: any) => !this.vetRoleTabs.includes(tab.type)
            );
            this.ausPreTravelTabs = this.ausPreTravelTabs.filter(
              (tab: any) => !this.vetRoleTabs.includes(tab.type)
            );
            if (this.isAUSCountry) {
              this.ausPreTravelNoteTypes =
                this.appMemory.static.aus_rv_pre_travel_notes.filter(
                  (tab: any) => !this.vetRoleTabs.includes(tab.type)
                );
            }

            this.noteTypes = this.appMemory.static.notes.filter(
              (tab: any) => !this.vetRoleTabs.includes(tab.type)
            );
          }

          if (!this.isAUSCountry) {
            this.setInitialTab();
            this.getHorseByUserRole();
          }
          this.isUserLoaded = true;
        }
      });
    });

    this.regionSelected.subscribe((region) => {
      if (region === usaRegionPK || region === usaRegionPC) {
        this.noteTypes = [
          {
            type: NoteType.sign,
          },
        ];
        this.hasSignNoteType = true;
        this.newNote.type = NoteType.sign;
      }

      if (region == usaRegionBC2023) {
        this.noteTypes = [
          {
            type: NoteType.attendingVetForm,
          },
        ];

        this.newNote.type = NoteType.attendingVetForm;
      }
    });

    this.getTranslation();
    this.getFarms();
  }

  setDeaultAdministerValue() {
    const administer = this.administers
      .filter(({ id }) => id == this.appMemory.user.id)
      .shift();
    this.administer = [administer];
    this.newTreatment.administer = new TreatmentAdminister(
      (!!administer && {
        user_id: administer.id,
      }) ||
        {}
    );
  }

  debug(e) {
    console.log(e);
  }

  searchDrugs(e) {
    var _drugs = this.getDrugsList();

    this.drugList = [];

    if (!this.isAUSCountry) {
      this.drugList[0] = _drugs[0];
    }

    if (_drugs) {
      let drugs = _drugs;
      if (environment.filterRegionForDrugs) {
        drugs = _drugs.filter(
          (drug: any) =>
            !!drug.region && drug.region === this.newHorse.farm.region
        );
      }
      if (drugs) {
        drugs.forEach((el, i) => {
          if (
            el.name.toLowerCase().indexOf(e.toLowerCase()) !== -1 &&
            (this.drugList.length == 0 ||
              el.name
                .toLowerCase()
                .indexOf(this.drugList[0].name.toLowerCase()) === -1)
          ) {
            this.drugList.push(el);
          }
        });
      }
    }
  }

  setInitialTab() {
    if (this.regionId == this.UKRegions.Aintree) {
      this.setTab(this.appMemory.static.treatments[0]);
    } else if (this.isHKCountry) {
      this.selectedTab = "md_f1a";
    } else if (this.isAUSCountry) {
      this.selectFirstAusRvForm();
    }
  }

  // EMR-641: auto-select the first form of the active RV parent tab
  // (Pre-Travel / Pre-Race) so the "Add treatment" / "Add form" button is
  // always visible. Only selects when no form is currently chosen, so horse
  // reloads don't reset a selection the user made.
  selectFirstAusRvForm() {
    if (!this.isAUSCountry || this.selectedTab) {
      return;
    }

    const isPreTravel = this.tabs.isPreTravelTab;
    const activeList = isPreTravel ? this.ausPreTravelTabs : this.ausTabs;

    if (!activeList || activeList.length === 0) {
      return;
    }

    const firstTab = activeList[0];
    const treatmentTypes = isPreTravel
      ? [
          "pre_travel_trainer_potential_long_acting",
          "pre_travel_trainer_routine",
          "pre_travel_trainer_routine_procedure_form",
        ]
      : [
          "trainer_potential_long_acting",
          "trainer_routine",
          "trainer_routine_procedure_form",
        ];

    this.setTab(
      firstTab,
      treatmentTypes.includes(firstTab.type) ? "treatment" : "note"
    );
  }

  getHorseDetails() {
    let horseCall;

    const { roles: [{ id: roleId } = {} as Role] = [] } =
      this.appMemory.user || {};

    switch (roleId) {
      case 1:
        horseCall = this.getHorse.bind(this);
        break;

      case 2:
        horseCall = this.getHorseA.bind(this);
        break;

      case 3:
        horseCall = this.getHorseV.bind(this);
        break;
    }

    horseCall();
  }

  getHorse(option?: string, extra?: string, isSetActiveTab: boolean = true) {
    if (option === "/treatments") {
      this.isRequestInProgress2 = true;
    }

    this.getService
      .getHorse(
        this.activatedRoute.params["value"]["horse_id"],
        option,
        extra,
        this.sortTreatmentObj
      )
      .then(
        (res: any) => {
          switch (option) {
            case "/treatments":
              this.treatments = res;
              this.sortArrayByDate(this.treatments.alive, "alive");
              this.sortArrayByDate(this.treatments.archive.data, "archive");
              this.paginationTr.nextPage =
                this.treatments.archive.next_page_url;
              break;

            default:
              this.horse = res;

              if (isSetActiveTab && this.isAUSCountry) {
                this.tabs.isPreTravelTab =
                  this.isAUSCountry && !this.horse.is_preTravel_forms_completed;
                this.tabs.isPreRaceTab =
                  this.isAUSCountry && this.horse.is_preTravel_forms_completed;
              }

              if (this.horse.eligible_forms && this.isHKCountry) {
                this.eligible_forms = JSON.parse(this.horse.eligible_forms);
              }

              this.regionId = this.horse.farm.region;

              this.tabs.displayAintreeTabs =
                this.regionId == this.UKRegions.Aintree;
              this.setInitialTab();

              this.appMemory.horse = this.horse;
              this.appMemory.pageInfo.title =
                this.horse.name || `${this.translation["horse"]}`;
              this.newHorse = Object.assign({}, this.horse);

              this.datePicker.currentDate_input = this.datePipe.transform(
                new Date(this.newHorse.birth),
                environment.dateFormat
              );
              this.datePicker.currentDate = new Date(this.newHorse.birth);

              var dateLocalPipe = this.dateLocalPipe.transform(
                this.newHorse.birth
              );
              this.datePicker.currentDate_input = this.datePipe.transform(
                dateLocalPipe,
                environment.dateFormat
              );
              this.datePicker.currentDate = dateLocalPipe;

              this.farmSelectModel[0]["id"] = this.newHorse.farm.id;
              this.farmSelectModel[0]["text"] = this.newHorse.farm.name;

              this.farmSelectModelLoaded = true;

              this.currentFarm = this.newHorse.farm;

              setTimeout(() => {
                if (this.horse.microchip) {
                  if (
                    this.appMemory.static.appStorageType ==
                    AppStorageType.fileSystem
                  ) {
                    this.imageLoader.files[0] = new File([""], "microchip");
                    this.imageLoader.files[0].src = this.horse.microchip;
                    this.imageLoader.fileChange(this.imageLoader.files[0]);
                    this.imageLoader.fileCounter = 1;
                  } else {
                    this.getPresignedUrls([this.horse.microchip], "horse");
                  }
                }
              });

              this.appMemory.pageInfo.title =
                this.horse.name || `${this.translation["horse"]}`;
              this.appMemory.pageInfo.isHorse = true;
              break;
          }
          // tslint:disable-next-line:no-unused-expression
          this.newHorse.farm &&
            this.regionSelected.next(this.newHorse.farm.region);
          this.isRequestInProgress2 = false;
        },
        (err: any) => {
          // console.log("ERR", err);
          this.isRequestInProgress2 = false;
        }
      );
  }

  getHorseA(option?: string, extra?: string, isSetActiveTab: boolean = true) {
    if (option === "/treatments") {
      this.isRequestInProgress2 = true;
    }

    this.getService
      .getHorseA(this.activatedRoute.params["value"]["horse_id"], option)
      .then(
        (res: any) => {
          switch (option) {
            case "/treatments":
              this.treatments = res;
              this.sortArrayByDate(this.treatments.alive, "alive");
              this.sortArrayByDate(this.treatments.archive.data, "archive");
              this.paginationTr.nextPage =
                this.treatments.archive.next_page_url;
              break;

            default:
              this.horse = res;

              if (isSetActiveTab && this.isAUSCountry) {
                this.tabs.isPreTravelTab =
                  this.isAUSCountry && !this.horse.is_preTravel_forms_completed;
                this.tabs.isPreRaceTab =
                  this.isAUSCountry && this.horse.is_preTravel_forms_completed;
              }

              if (this.horse.eligible_forms && this.isHKCountry) {
                this.eligible_forms = JSON.parse(this.horse.eligible_forms);
              }

              this.regionId = this.horse.farm.region;
              this.tabs.displayAintreeTabs =
                this.regionId == this.UKRegions.Aintree;

              this.setInitialTab();

              this.appMemory.horse = this.horse;
              this.newHorse = Object.assign({}, this.horse);

              var dateLocalPipe = this.dateLocalPipe.transform(
                this.newHorse.birth
              );
              this.datePicker.currentDate_input = this.datePipe.transform(
                dateLocalPipe,
                environment.dateFormat
              );
              this.datePicker.currentDate = dateLocalPipe;

              this.farmSelectModel[0]["id"] = this.newHorse.farm.id;
              this.farmSelectModel[0]["text"] = this.newHorse.farm.name;

              this.farmSelectModelLoaded = true;

              setTimeout(() => {
                if (this.horse.microchip) {
                  if (
                    this.appMemory.static.appStorageType ==
                    AppStorageType.fileSystem
                  ) {
                    this.imageLoader.files[0] = new File([""], "microchip");
                    this.imageLoader.files[0].src = this.horse.microchip;
                    this.imageLoader.fileChange(this.imageLoader.files[0]);
                    this.imageLoader.fileCounter = 1;
                  } else {
                    this.getPresignedUrls([this.horse.microchip], "horse");
                  }
                }
              });

              this.appMemory.pageInfo.title =
                this.horse.name || `${this.translation["horse"]}`;
              this.appMemory.pageInfo.isHorse = true;
              break;
          }
          // tslint:disable-next-line:no-unused-expression
          this.newHorse.farm &&
            this.regionSelected.next(this.newHorse.farm.region);
          this.isRequestInProgress2 = false;
        },
        (err: any) => {
          console.log("ERR", err);
          this.isRequestInProgress2 = false;
        }
      );
  }

  getHorseV(option?: string, extra?: string, isSetActiveTab: boolean = true) {
    if (option === "/treatments") {
      this.isRequestInProgress2 = true;
    }

    this.getService
      .getHorseV(this.activatedRoute.params["value"]["horse_id"], option)
      .then(
        (res: any) => {
          switch (option) {
            case "/treatments":
              this.treatments = res;
              this.sortArrayByDate(this.treatments.alive, "alive");
              this.sortArrayByDate(this.treatments.archive.data, "archive");
              this.paginationTr.nextPage =
                this.treatments.archive.next_page_url;
              break;

            default:
              this.horse = res;

              if (isSetActiveTab && this.isAUSCountry) {
                this.tabs.isPreTravelTab =
                  this.isAUSCountry && !this.horse.is_preTravel_forms_completed;
                this.tabs.isPreRaceTab =
                  this.isAUSCountry && this.horse.is_preTravel_forms_completed;
              }

              if (this.horse.eligible_forms && this.isHKCountry) {
                this.eligible_forms = JSON.parse(this.horse.eligible_forms);
              }

              this.regionId = this.horse.farm.region;
              this.tabs.displayAintreeTabs =
                this.regionId == this.UKRegions.Aintree;
              this.setInitialTab();

              this.appMemory.horse = this.horse;
              this.newHorse = Object.assign({}, this.horse);

              var dateLocalPipe = this.dateLocalPipe.transform(
                this.newHorse.birth
              );
              this.datePicker.currentDate_input = this.datePipe.transform(
                dateLocalPipe,
                environment.dateFormat
              );
              this.datePicker.currentDate = dateLocalPipe;

              this.farmSelectModel[0]["id"] = this.newHorse.farm.id;
              this.farmSelectModel[0]["text"] = this.newHorse.farm.name;

              this.farmSelectModelLoaded = true;

              setTimeout(() => {
                if (this.horse.microchip) {
                  if (
                    this.appMemory.static.appStorageType ==
                    AppStorageType.fileSystem
                  ) {
                    this.imageLoader.files[0] = new File([""], "microchip");
                    this.imageLoader.files[0].src = this.horse.microchip;
                    this.imageLoader.fileChange(this.imageLoader.files[0]);
                    this.imageLoader.fileCounter = 1;
                  } else {
                    this.getPresignedUrls([this.horse.microchip], "horse");
                  }
                }
              });

              this.appMemory.pageInfo.title =
                this.horse.name || `${this.translation["horse"]}`;
              this.appMemory.pageInfo.isHorse = true;
              break;
          }
          // tslint:disable-next-line:no-unused-expression
          this.newHorse.farm &&
            this.regionSelected.next(this.newHorse.farm.region);

          this.isRequestInProgress2 = false;
        },
        (err: any) => {
          console.log("ERR", err);
          this.isRequestInProgress2 = false;
        }
      );
  }

  sortArrayByDate(array: any, type: string) {
    this.isRequestInProgress2 = true;

    switch (type) {
      case "alive":
        this.treatmentsByDate = [];

        let tmp = undefined;
        array.forEach((e, i) => {
          e.date = e.start_date; // .slice(0, -9);
          if (!tmp) {
            e.data = [e];
            tmp = e;
            if (i === array.length - 1) {
              this.treatmentsByDate.push(tmp);
              tmp = undefined;
            }
          } else {
            if (e.date === tmp.date) {
              tmp.data.push(e);
              if (i === array.length - 1) {
                this.treatmentsByDate.push(tmp);
                tmp = undefined;
              }
            } else {
              this.treatmentsByDate.push(tmp);
              tmp = undefined;
              e.data = [e];
              tmp = e;
              if (i === array.length - 1) {
                this.treatmentsByDate.push(tmp);
                tmp = undefined;
              }
            }
          }
        });
        if (tmp) {
          this.treatmentsByDate.push(tmp);
          tmp = undefined;
        }
        break;

      case "archive":
        this.treatmentsByDateArchive = [];

        let tmp2 = undefined;
        array.forEach((e, i) => {
          e.date = e.start_date; // .slice(0, -9);
          if (!tmp2) {
            e.data = [e];
            tmp2 = e;
            if (i === array.length - 1) {
              this.treatmentsByDateArchive.push(tmp2);
              tmp2 = undefined;
            }
          } else {
            if (e.date === tmp2.date) {
              tmp2.data.push(e);
              if (i === array.length - 1) {
                this.treatmentsByDateArchive.push(tmp2);
                tmp2 = undefined;
              }
            } else {
              this.treatmentsByDateArchive.push(tmp2);
              tmp2 = undefined;
              e.data = [e];
              tmp2 = e;
              if (i === array.length - 1) {
                this.treatmentsByDateArchive.push(tmp2);
                tmp2 = undefined;
              }
            }
          }
        });
        if (tmp2) {
          this.treatmentsByDateArchive.push(tmp2);
          tmp2 = undefined;
        }
        break;
    }

    this.isRequestInProgress2 = false;
  }

  getNotes(role: string, type?: string) {
    this.isRequestInProgress3 = true;
    this.getService
      .getNotes(
        this.activatedRoute.params["value"]["horse_id"],
        role,
        type,
        this.sortNoteObj
      )
      .then(
        (res: any) => {
          this.notes = res.data;

          if (res.next_page_url) {
            this.pagination.nextPage = res.next_page_url;
          } else {
            this.pagination.nextPage = res.next_page_url;
          }

          this.isRequestInProgress3 = false;
        },
        (err: any) => {
          console.log("ERR", err);
          this.isRequestInProgress3 = false;
        }
      );
  }

  addNewData(items: any) {
    if (this.tabs.isNotes) {
      if (
        this.pagination.nextPage === null ||
        this.pagination.inProgress ||
        this.pagination.nextPage === ""
      ) {
        return;
      }

      this.pagination.inProgress = true;
      this.getService.rawRequest(this.pagination.nextPage).then(
        (res: any) => {
          res.data.forEach((item: any) => {
            items.push(item);
          });

          if (res.next_page_url) {
            this.pagination.nextPage = res.next_page_url;
          } else {
            this.pagination.nextPage = res.next_page_url;
          }

          this.pagination.inProgress = false;
        },
        (err: any) => {
          this.pagination.inProgress = false;
        }
      );
    } else if (this.tabs.isTreatments) {
      if (
        this.paginationTr.nextPage === null ||
        this.paginationTr.inProgress ||
        this.paginationTr.nextPage === ""
      ) {
        return;
      }

      this.paginationTr.inProgress = true;

      this.getService.rawRequest(this.paginationTr.nextPage).then(
        (res: any) => {
          let tmp2 = undefined;
          let tmp3 =
            this.treatmentsByDateArchive[
              this.treatmentsByDateArchive.length - 1
            ];
          const array = res.archive.data;
          array.forEach((e, i) => {
            e.date = e.updated_at; // .slice(0, -9);
            if (tmp3 && tmp3.date === e.date) {
              this.treatmentsByDateArchive[
                this.treatmentsByDateArchive.length - 1
              ].data.push(e);
            } else {
              tmp3 = undefined;
              if (!tmp2) {
                e.data = [e];
                tmp2 = e;
                if (i === array.length - 1) {
                  this.treatmentsByDateArchive.push(tmp2);
                  tmp2 = undefined;
                }
              } else {
                if (e.date === tmp2.date) {
                  tmp2.data.push(e);
                  if (i === array.length - 1) {
                    this.treatmentsByDateArchive.push(tmp2);
                    tmp2 = undefined;
                  }
                } else {
                  this.treatmentsByDateArchive.push(tmp2);
                  tmp2 = undefined;
                  e.data = [e];
                  tmp2 = e;
                  if (i === array.length - 1) {
                    this.treatmentsByDateArchive.push(tmp2);
                    tmp2 = undefined;
                  }
                }
              }
            }
          });
          if (tmp2) {
            this.treatmentsByDateArchive.push(tmp2);
            tmp2 = undefined;
          }
          this.paginationTr.nextPage = res.archive.next_page_url;

          this.paginationTr.inProgress = false;
        },
        (err: any) => {
          this.paginationTr.inProgress = false;
        }
      );
    } else if (this.tabs.isVaccinations) {
      if (
        this.paginationVc.nextPage === null ||
        this.paginationVc.inProgress ||
        this.paginationVc.nextPage === ""
      ) {
        return;
      }

      this.paginationVc.inProgress = true;
      this.getService.rawRequest(this.paginationVc.nextPage).then(
        (res: any) => {
          res.data.forEach((item: any) => {
            items.push(item);
          });

          if (res.next_page_url) {
            this.paginationVc.nextPage = res.next_page_url;
          } else {
            this.paginationVc.nextPage = res.next_page_url;
          }

          this.paginationVc.inProgress = false;
        },
        (err: any) => {
          this.paginationVc.inProgress = false;
        }
      );
    }
  }

  addVideo(role: string) {
    const formData: FormData = new FormData();

    this.isRequestInProgress = true;

    formData.append("type", this.newNote.type);

    if (this.newNote.date === undefined) {
      this.setNoteDate(new Date());
    }
    formData.append("date", this.newNote.date);

    if (this.newNote.src && this.isImagesChanged) {
      if (this.appMemory.static.appStorageType == AppStorageType.fileSystem) {
        this.newNote.src.forEach((e, i) => {
          formData.append(
            "images[" + i + "][content]",
            e.file,
            e.file.name || "defaultFileName"
          );
          formData.append("images[" + i + "][description]", "");
        });
      } else {
        var presignedUrls = this.newNote.src.map((e, i) => ({
          filename: e.file.name,
          description: "",
          update_image: true,
        }));

        formData.append("presigned_urls", JSON.stringify(presignedUrls));
      }

      this.getService.addNote(this.horseId, role, formData).then(
        (res: any) => {
          if (
            this.newNote.src &&
            res.presigned_urls &&
            res.presigned_urls.length > 0
          ) {
            this.uploadFilesToS3(res.presigned_urls, this.newNote.src);
          }

          this.hideModal();
          this.notes = [];

          this.getHorseByUserRole({
            excludeHorse: true,
            excludeTreatments: true,
            excludeVaccination: true,
            excludeNotes: false,
          });

          this.isRequestInProgress = false;
          this.notificationsService.success(
            `${this.translation["addNote"]}`,
            `${this.translation["note"]} ${this.translation["addedSuccess"]}`
          );
        },
        (err: any) => {
          console.log("ERR", err);
          this.isRequestInProgress = false;
          this.notificationsService.error(
            `${this.translation["addNote"]}`,
            `${this.translation["errorOccurred"]} ${this.processServerError(
              err
            )}`
          );
        }
      );
    }
  }

  createNote(role: string, form: any) {
    if (
      form.form.invalid ||
      (this.newNote.type === "weight" && !this.newNote.weight)
    ) {
      return;
    }

    console.log(this.newNote);

    const formData: FormData = new FormData();

    this.isRequestInProgress = true;

    if (this.hasSignNoteType) {
      this.newNote.type = NoteType.sign;
    }

    if (this.isUkCountry) {
      Object.keys(this.newNote)
        .filter((key) => !["src"].includes(key))
        .forEach((key) => {
          formData.append(key, this.newNote[key]);
        });

      if (!this.newNote.type) {
        this.newNote.type = this.selectedTab;
      }
    }

    if (this.isUSCountry || this.isHKCountry || this.isAUSCountry) {
      Object.keys(this.newNote)
        .filter((key) => key.includes("comments"))
        .forEach((key) => {
          formData.append(key, this.newNote[key]);
        });
    }

    if (this.newNote.type !== "weight") {
      delete this.newNote.weight;
    } else {
      formData.append("weight", this.newNote.weight);
    }

    formData.append("title", this.newNote.title ? this.newNote.title : "");
    formData.append(
      "description",
      this.newNote.description ? this.newNote.description : ""
    );
    formData.append("type", this.newNote.type);
    if (this.newNote.date === undefined) {
      this.setNoteDate(new Date());
    }
    formData.append("date", this.newNote.date);

    if (this.newNote.src && this.isImagesChanged) {
      const imgs = $(".with_description .image-container .image");
      if (this.appMemory.static.appStorageType == AppStorageType.fileSystem) {
        this.newNote.src.forEach((e, i) => {
          formData.append(
            "images[" + i + "][content]",
            e.file,
            e.file.name || "defaultFileName"
          );
          formData.append(
            "images[" + i + "][description]",
            $(imgs[i]).find("input").val()
          );
        });
      } else {
        var presignedUrls = this.newNote.src.map((e, i) => ({
          filename: e.file.name,
          description: $(imgs[i]).find("input").val(),
          update_image: true,
        }));

        formData.append("presigned_urls", JSON.stringify(presignedUrls));
      }
    }

    this.getService.addNote(this.horseId, role, formData).then(
      (res: any) => {
        $("#assistant-invite-email-box").removeClass("input--filled");

        if (
          this.newNote.src &&
          res.presigned_urls &&
          res.presigned_urls.length > 0
        ) {
          this.uploadFilesToS3(res.presigned_urls, this.newNote.src);
        }

        this.clearUserInput(form);
        this.hideModal();
        this.notes = [];

        switch (this.appMemory.user.roles[0].id) {
          case 1:
            this.getHorse("", "", false);
            break;
          case 2:
            this.getHorseA("", "", false);
            break;
          case 3:
            this.getHorseV("", "", false);
            break;
        }

        this.getHorseByUserRole({
          excludeHorse: true,
          excludeTreatments: true,
          excludeVaccination: true,
          excludeNotes: false,
        });

        this.isRequestInProgress = false;
        this.notificationsService.success(
          `${this.translation["addNote"]}`,
          `${this.translation["note"]} ${this.translation["addedSuccess"]}`
        );
      },
      (err: any) => {
        console.log("ERR", err);
        this.isRequestInProgress = false;
        this.notificationsService.error(
          `${this.translation["addNote"]}`,
          `${this.translation["errorOccurred"]} ${this.processServerError(err)}`
        );
      }
    );
  }

  updateNote(role: string, form: any) {
    if (form.form.invalid) {
      return;
    }

    this.isRequestInProgress = true;

    const formData: FormData = new FormData();

    if (this.isUkCountry) {
      Object.keys(this.newNote).forEach((key) => {
        // tslint:disable-next-line:curly
        if (
          ["user", "horse", "images", "type", "description", "title"].includes(
            key
          )
        )
          return;
        formData.append(key, this.newNote[key]);
      });
    }

    if (!this.newNote.type) {
      this.newNote.type = this.selectedTab;
    }

    formData.append("type", this.newNote.type);

    if (this.newNote.type !== "weight") {
      delete this.newNote.weight;
    } else {
      formData.append("weight", this.newNote.weight);
    }

    if (this.isUSCountry || this.isHKCountry || this.isAUSCountry) {
      Object.keys(this.newNote)
        .filter((key) => key.includes("comments"))
        .forEach((key) => {
          formData.append(key, this.newNote[key]);
        });
    }

    formData.append("title", this.newNote.title ? this.newNote.title : "");
    formData.append(
      "description",
      this.newNote.description ? this.newNote.description : ""
    );
    if (this.newNote.date) {
      formData.append("date", this.newNote.date);
    }

    if (this.newNote.images) {
      const del = [];
      this.newNote.images.forEach((el) => {
        let flag = true;
        this.newNote.srcs.forEach((el2) => {
          if (flag && el2.id === el.id) {
            flag = false;
          }
        });
        if (flag) {
          del.push(el.id);
        }
      });
      if (del.length > 0) {
        const requestObj = {};
        switch (role) {
          case "/vet":
            requestObj["url"] = "/note-request-vet/" + this.newNote.id;
            break;
          case "/assistant":
            requestObj["url"] = "/note-request/" + this.newNote.id;
            break;
          case "/instructor":
            requestObj["url"] = "/instructor/note/" + this.newNote.id;
            break;
        }
        requestObj["params"] = { "images[]": del };
        this.getService.removeImages(requestObj).then(
          (res) => {
            this.getHorseByUserRole({
              excludeHorse: true,
              excludeTreatments: true,
              excludeNotes: false,
              excludeVaccination: true,
            });
          },
          (err) => {
            // console.log(err);
          }
        );
      }
    }

    var update_image = false;
    if (this.newNote.src && this.isImagesChanged) {
      update_image = true;
      const imgs = $(".with_description .image-container .image");
      if (this.appMemory.static.appStorageType == AppStorageType.fileSystem) {
        this.newNote.src.forEach((e, i) => {
          formData.append("images[" + i + "][content]", e.file, e.file.name);
          formData.append(
            "images[" + i + "][description]",
            $(imgs[i]).find("input").val()
          );
        });
      } else {
        var presignedUrls = this.newNote.src.map((e, i) => ({
          filename: e.file.name,
          description: $(imgs[i]).find("input").val(),
          update_image: update_image,
        }));

        formData.append("presigned_urls", JSON.stringify(presignedUrls));
      }
    }
    // tslint:disable-next-line:one-line
    else {
      formData.append("images_exists", true);
    }

    this.getService
      .updateNoteById(
        this.horseId,
        role,
        // this.newNote
        formData,
        this.newNote.id
      )
      .then(
        (res: any) => {
          $("#assistant-invite-email-box").removeClass("input--filled");

          if (
            this.newNote.src &&
            res.presigned_urls &&
            res.presigned_urls.length > 0
          ) {
            this.uploadFilesToS3(res.presigned_urls, this.newNote.src);
            update_image = false;
          }

          this.clearUserInput(form);
          this.hideModal();
          this.notes = [];
          this.getHorseByUserRole({
            excludeHorse: true,
            excludeTreatments: true,
            excludeNotes: false,
            excludeVaccination: true,
          });
          this.isRequestInProgress = false;
          this.notificationsService.success(
            `${this.translation["editNote"]}`,
            `${this.translation["note"]} ${this.translation["edittedSuccess"]}`
          );
        },
        (err: any) => {
          console.log("ERR", err._body);
          this.isRequestInProgress = false;
          this.notificationsService.error(
            `${this.translation["editNote"]}`,
            `${this.translation["errorOccurred"]} ${this.processServerError(
              err
            )}`
          );
        }
      );
  }

  clearUserInput(form?: any, close?: boolean) {
    this.clearImages();
    this.serverError = null;
    this.serverErrorValidate = null;
    if (form) {
      form.resetForm();
    }

    this.newNote = new Note();

    if (this.isUSCountry) {
      this.newNote = new Note(this.hasSignNoteType);
    }

    if (this.newHorse.farm && this.newHorse.farm.region == usaRegionBC2023) {
      this.newNote.type = NoteType.attendingVetForm;
    }

    if (this.isHKCountry || this.isAUSCountry) {
      this.newNote.type = this.selectedTab;
    }

    this.newTreatment = new Treatment();

    if (this.isAUSCountry) {
      this.newTreatment.type = this.selectedTab;
      this.showOtherSubstancesInput = undefined;
    }

    this.showEndDateField = true;

    this.newVaccination = new Vaccination();
    this.measuresSelectorModel = [];
    this.frequencySelectorModel = [];
    this.weightsSelectorModel = [];
    this.drugTypesSelectorModel = [];
    this.hasNoTreatment = false;
    this.administer = [];
    this.hasNoTreatment = false;

    $("#note-title-box").removeClass("input--filled");
    $("#note-descr-box").removeClass("input--filled");
    $("#comment-box").removeClass("input--filled");
    $("#quantity-box").removeClass("input--filled");
    $("#reason-box").removeClass("input--filled");
    /*$('#detection_time-box').removeClass('input--filled');*/
    $("#duration-box").removeClass("input--filled");
    $("#microchip-number-box").removeClass("input--filled");

    this.dateRangeErrorMessage = {} as {
      from?: string;
      due?: string;
      date?: string;
    };
    this.dateRangeTreatmentErrorMessage = {} as {
      from?: string;
      due?: string;
      date?: string;
    };
    this.dateRangeEditTreatmentErrorMessage = {} as {
      from?: string;
      due?: string;
      date?: string;
    };
    this.datePicker.isActive = false;
    this.datePicker2.isActive = false;
    this.datePicker3.isActive = false;
    this.datePicker4.isActive = false;
    this.datePicker5.isActive = false;
    this.datePickerAddNote.isActive = false;
    this.isAddTreatment = false;

    this.datePicker4.currentDate_input = "";
    this.datePicker2.currentDate_input = "";

    this.datePicker4.minDate = new Date(
      new Date().setFullYear(new Date().getFullYear() - 40)
    );
    this.datePicker4.maxDate = new Date(
      new Date().setFullYear(new Date().getFullYear() + 40)
    );

    this.isFormInViewMode = false;
  }

  addNodeSetDefaultDate() {
    this.datePickerAddNote.currentDate_input = this.datePipe.transform(
      new Date(),
      environment.dateFormat
    );
  }

  hideModal(noclear?: boolean) {
    if (!noclear) {
      this.clearImages();
    }
    $(".modal.open").removeClass("open");
    $("body").removeClass("modal-open");
  }
  clearImages() {
    if (this.imageLoader22) {
      this.imageLoader22.deleteAll();
    }
    if (this.imageLoader2) {
      this.imageLoader2.deleteAll();
    }
    if (this.imageLoader23) {
      this.imageLoader23.deleteAll();
    }
    if (this.imageLoader24) {
      this.imageLoader24.deleteAll();
    }
  }

  getFarms(name?: string) {
    if (!this.farmsSelector) {
      this.farmsSelector = {
        items: [],
      };
    } else {
      this.farmsSelector.items = [];
    }
    this.loadSuggestion = true;
    if (name) {
      return (this.farms = this.farms.filter((farm) =>
        new RegExp(".*" + name + ".*").test(farm.name)
      ));
    }
    return this.getService.getAllFarms().then(
      (res) => {
        res.forEach((e) => {
          e.text = e.name;
        });

        this.farms = res;
        this.loadSuggestion = false;

        setTimeout(() => {
          // this.farmsSelector.open();
        }, 100);
      },
      (err) => {
        this.loadSuggestion = false;
      }
    );
  }

  setFarmId(e) {
    const selectedFarm: Farm = this.farms.find((item: Farm) => item.id == e.id);

    if (
      this.currentFarm.id != e.id &&
      selectedFarm &&
      selectedFarm.region == this.UKRegions.Aintree
    ) {
      if (
        confirm(
          "Are you sure you want to move this horse into 'Aintree'? Be aware this will mean the BHA will now have access to the last 3 months of records for this horse"
        )
      ) {
        this.newHorse.farm_id = e.id;
      } else {
        this.farmsSelector.active = [
          { id: this.currentFarm.id, text: this.currentFarm.name },
        ];
      }
    } else {
      this.newHorse.farm_id = e.id;

      if (selectedFarm && selectedFarm.region != usaRegionBC2023) {
        this.newHorse.hisa_id = "";
      }
    }
  }

  setMeasure(e) {
    this.newTreatment.quantity_measure = e.id;
  }

  setDrugType(e) {
    this.newTreatment.drug_type = e.id;
  }

  setFrequencyType(e) {
    if (e.text != FrequencyType.Other) {
      this.newTreatment.frequency = "";
    }

    if (e.text == FrequencyType.SingleUse) {
      this.showEndDateField = false;
      this.newTreatment.withdrawal = "";
    } else {
      this.showEndDateField = true;
    }

    this.newTreatment.frequency_type = e.text;
  }

  setWeight(e) {
    this.newNote.weight = e.text;
  }

  setImage(file: File) {
    const that = this;
    new ImageCompressor(file, {
      maxWidth: 1000,
      maxHeight: 668,
      success(result) {
        that.newHorse.microchip = result;
        that.isMicrochipChanged = true;
      },
      error(e) {
        console.log(e.message);
        that.notificationsService.error(
          `${this.translation["uploadImage"]}`,
          `${this.translation["errorOccurred"]}`
        );
      },
    });
  }

  setNoteImages(files: File[]) {
    const that = this;

    this.newNote.src = files;
    this.isImagesChanged = true;

    if (this.newNote.type != "video-submission") {
      setTimeout(() => {
        for (let i = 0; i < files.length; i++) {
          if (!(<any>files[i]).compressed) {
            new ImageCompressor((<any>files[i]).file, {
              maxWidth: 1000,
              maxHeight: 668,
              success(result) {
                (<any>files[i]).file = result;
                (<any>files[i]).compressed = true;
              },
              error(e) {
                // console.log(e.message);
                // that.notificationsService.error(
                //     `${this.translation['uploadImage']}`,
                //     `${this.translation['errorOccurred']}`
                // );
              },
            });
          }
        }

        const imgs = $(".with_description .image-container .image");
        imgs.addClass("image-block");

        imgs.each((i) => {
          if ($(imgs[i]).find(".remove_on_remove_img").length === 0) {
            const a = `<div class="box-control remove_on_remove_img">
                <input type="text"
                       class="form-control input__field"
                       name="image_description_${i}"
                       autocomplete="off">
                <label class="input__label">
                  <span>${this.translation["description"]}</span>
                </label>
              </div>`;
            $(a).appendTo(imgs[i]);
          }
        });
      }, 200);
    }
  }

  setImages(files: File[]) {
    const that = this;

    this.newTreatment.src = files;
    this.isImagesChanged = true;

    setTimeout(() => {
      for (let i = 0; i < files.length; i++) {
        if (
          (<any>files[i]).file.type === "image/jpg" ||
          (<any>files[i]).file.type === "image/png"
        ) {
          if (!(<any>files[i]).compressed) {
            new ImageCompressor((<any>files[i]).file, {
              maxWidth: 1000,
              maxHeight: 668,
              success(result) {
                (<any>files[i]).file = result;
                (<any>files[i]).compressed = true;
              },
              error(e) {
                console.log(e.message);
                that.notificationsService.error(
                  `${this.translation["uploadImage"]}`,
                  `${this.translation["errorOccurred"]}`
                );
              },
            });
          }
        }
      }

      const imgs = $(".with_description .image-container .image");
      imgs.addClass("image-block");

      imgs.each((i) => {
        if ($(imgs[i]).find(".remove_on_remove_img").length === 0) {
          const a = `<div class="box-control remove_on_remove_img">
              <input type="text"
                     class="form-control input__field"
                     name="image_description_${i}"
                     autocomplete="off">
              <label class="input__label">
                <span>${this.translation["description"]}</span>
              </label>
            </div>`;
          $(a).appendTo(imgs[i]);
        }
      });
    }, 200);
  }

  public datePickerMask = {
    guide: true,
    showMask: true,
    mask: [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/],
  };

  formatDate(date) {
    if (date) {
      const arr = date.split("/");
      switch (environment.dateFormat) {
        case "MM/dd/yyyy":
          return arr[0] + "/" + arr[1] + "/" + arr[2];
        case "dd/MM/yyyy":
        default:
          return arr[1] + "/" + arr[0] + "/" + arr[2];
      }
    }
  }

  setNoteDate(date) {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.note_date = null;
    }
    this.newNote.date = this.datePipe
      .transform(date, "yyyy-MM-dd")
      .replace(/\s/g, "T");
    this.datePickerAddNote.currentDate = date;
    this.datePickerAddNote.currentDate_input = this.datePipe.transform(
      date,
      environment.dateFormat
    );
  }

  setNoteDateInput() {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.note_date = null;
    }
    if (
      new Date(
        this.formatDate(this.datePickerAddNote.currentDate_input)
      ).getTime() > this.datePickerAddNote.maxDate.getTime() ||
      new Date(
        this.formatDate(this.datePickerAddNote.currentDate_input)
      ).getTime() < this.datePickerAddNote.minDate.getTime() ||
      new Date(
        this.formatDate(this.datePickerAddNote.currentDate_input)
      ).toDateString() === "Invalid Date"
    ) {
      if (this.serverErrorValidate) {
        this.serverErrorValidate.note_date = "CORE.invalidDate";
      } else {
        this.serverErrorValidate = { note_date: "CORE.invalidDate" };
      }
      return;
    }
    this.datePickerAddNote.currentDate = new Date(
      this.formatDate(this.datePickerAddNote.currentDate_input)
    );
    this.newNote.date = this.datePipe.transform(
      this.formatDate(this.datePickerAddNote.currentDate_input),
      "yyyy-MM-dd"
    );
    this.datePickerAddNote.isActive = false;
  }

  setBirthDate(date) {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.birth = null;
    }
    this.newHorse.birth = this.datePipe
      .transform(date, "yyyy-MM-dd")
      .replace(/\s/g, "T");

    var dateLocalPipe = this.dateLocalPipe.transform(this.newHorse.birth);
    this.datePicker.currentDate = dateLocalPipe;
    this.datePicker.currentDate_input = this.datePipe.transform(
      dateLocalPipe,
      environment.dateFormat
    );
  }

  setBirthDateInput() {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.birth = null;
    }
    if (
      new Date(this.formatDate(this.datePicker.currentDate_input)).getTime() >
        this.datePicker.maxDate.getTime() ||
      new Date(this.formatDate(this.datePicker.currentDate_input)).getTime() <
        this.datePicker.minDate.getTime() ||
      new Date(
        this.formatDate(this.datePicker.currentDate_input)
      ).toDateString() === "Invalid Date"
    ) {
      if (this.serverErrorValidate) {
        this.serverErrorValidate.birth = "CORE.invalidDate";
      } else {
        this.serverErrorValidate = { birth: "CORE.invalidDate" };
      }
      return;
    }
    this.newHorse.birth = this.datePipe.transform(
      this.formatDate(this.datePicker.currentDate_input),
      "yyyy-MM-dd"
    );
    this.datePicker.currentDate = new Date(
      this.formatDate(this.datePicker.currentDate_input)
    );
    this.datePicker.isActive = false;
  }

  setVaccinationDate(date) {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.vaccination_date = null;
    }

    this.newVaccination.date = this.datePipe
      .transform(date, "yyyy-MM-dd")
      .replace(/\s/g, "T");
    this.datePicker.currentDate = date;
    this.datePicker3.currentDate_input = this.datePipe.transform(
      date,
      environment.dateFormat
    );
    this.datePicker5.minDate = date;
  }

  setVaccinationDateInput() {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.vaccination_date = null;
    }
    // (new Date(this.formatDate(this.datePicker3.currentDate_input))).getTime() > this.datePicker3.maxDate.getTime() ||
    // (new Date(this.formatDate(this.datePicker3.currentDate_input))).getTime() < this.datePicker3.minDate.getTime() ||
    if (
      new Date(
        this.formatDate(this.datePicker3.currentDate_input)
      ).toDateString() === "Invalid Date"
    ) {
      this.invalidVaccinationForm = true;
      this.newVaccination.date = null;
      this.datePicker3.currentDate = null;
      if (this.serverErrorValidate) {
        this.serverErrorValidate.vaccination_date = "CORE.invalidDate";
      } else {
        this.serverErrorValidate = { vaccination_date: "CORE.invalidDate" };
      }
      return;
    }
    this.newVaccination.date = this.datePipe.transform(
      this.formatDate(this.datePicker3.currentDate_input),
      "yyyy-MM-dd"
    );
    this.datePicker3.currentDate = new Date(
      this.formatDate(this.datePicker3.currentDate_input)
    );
    this.datePicker3.isActive = false;
  }

  removeVaccinationDate() {
    this.newVaccination.date = undefined;
    this.datePicker3.currentDate_input = undefined;
    this.datePicker.currentDate = undefined;
    this.datePicker5.minDate = new Date(
      new Date().setFullYear(new Date().getFullYear() - 3)
    );
  }

  setNextVaccinationDate(date) {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.immunization = null;
    }
    this.newVaccination.immunization = this.datePipe
      .transform(date, "yyyy-MM-dd")
      .replace(/\s/g, "T");
    this.datePicker5.currentDate = date;
    this.datePicker5.currentDate_input = this.datePipe.transform(
      date,
      environment.dateFormat
    );
    this.datePicker3.maxDate = date;
  }

  setNextVaccinationDateInput() {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.immunization = null;
    }
    // (new Date(this.formatDate(this.datePicker5.currentDate_input))).getTime() > this.datePicker5.maxDate.getTime() ||
    // (new Date(this.formatDate(this.datePicker5.currentDate_input))).getTime() < this.datePicker5.minDate.getTime() ||
    if (
      new Date(
        this.formatDate(this.datePicker5.currentDate_input)
      ).toDateString() === "Invalid Date"
    ) {
      if (this.serverErrorValidate) {
        this.serverErrorValidate.immunization = "CORE.invalidDate";
      } else {
        this.serverErrorValidate = { immunization: "CORE.invalidDate" };
      }
      return;
    }
    this.newVaccination.immunization = this.datePipe.transform(
      this.formatDate(this.datePicker5.currentDate_input),
      "yyyy-MM-dd"
    );
    this.datePicker5.currentDate = new Date(
      this.formatDate(this.datePicker5.currentDate_input)
    );
    this.datePicker5.isActive = false;
  }

  removeNextVaccinationDate() {
    this.newVaccination.immunization = undefined;
    this.datePicker5.currentDate_input = undefined;
    this.datePicker.currentDate = undefined;
    this.datePicker3.maxDate = new Date(
      new Date().setFullYear(new Date().getFullYear() + 3)
    );
  }

  /**
   * Check validity of period and disabled "Pick date" button
   * @returns {void}
   */
  checknewVaccinationValidity(): void {
    const options = { year: "numeric", month: "numeric", day: "numeric" };
    if (
      this.newVaccination.date &&
      this.newVaccination.immunization &&
      this.newVaccination.date > this.newVaccination.immunization
    ) {
      this.dateRangeErrorMessage = {
        from: "OTHER.adminGreaterNextAdmin",
        due: "OTHER.adminGreaterNextAdmin",
      };
      this.invalidVaccinationForm = true;
    }
    // else if (new Date(this.newVaccination.date).getTime() < new Date(this.appMemory.user.created_at).getTime()) {
    //     this.dateRangeErrorMessage = {
    //         from: `OTHER.dateExceededReg`,
    //         date: new Date(this.appMemory.user.created_at).toLocaleString('en-GB', options)
    //     };
    //     this.invalidVaccinationForm = true;
    // } else if (new Date(this.newVaccination.immunization).getTime() < new Date(this.appMemory.user.created_at).getTime()) {
    //     this.dateRangeErrorMessage = {
    //         due: `OTHER.dateExceededReg`,
    //         date: new Date(this.appMemory.user.created_at).toLocaleString('en-GB', options)
    //     };
    //     this.invalidVaccinationForm = true;
    // }
    else {
      this.dateRangeErrorMessage = {};
      this.invalidVaccinationForm = false;
    }
  }

  /**
   * Check validity of period and disabled "Pick date" button
   * @returns {void}
   */
  checkEditTreatmentValidity(): void {
    const options = { year: "numeric", month: "numeric", day: "numeric" };
    if (
      this.newTreatment.start_date &&
      this.newTreatment.withdrawal &&
      this.newTreatment.start_date > this.newTreatment.withdrawal
    ) {
      this.dateRangeEditTreatmentErrorMessage = {
        from: "OTHER.startDateGraterEndDate",
        due: "OTHER.startDateGraterEndDate",
      };
      this.invalidTreatmentForm = true;
    }
    // else if (new Date(this.newTreatment.start_date).getTime() < new Date(this.appMemory.user.created_at).getTime()) {
    //     this.dateRangeEditTreatmentErrorMessage = {
    //         from: `OTHER.dateExceededReg`,
    //         date: new Date(this.appMemory.user.created_at).toLocaleString('en-GB', options)
    //     };
    //     this.invalidTreatmentForm = true;
    // } else if (new Date(this.newTreatment.withdrawal).getTime() < new Date(this.appMemory.user.created_at).getTime()) {
    //     this.dateRangeEditTreatmentErrorMessage = {
    //         due: `OTHER.dateExceededReg`,
    //         date: new Date(this.appMemory.user.created_at).toLocaleString('en-GB', options)
    //     };
    //     this.invalidTreatmentForm = true;
    // }
    else {
      this.dateRangeEditTreatmentErrorMessage = {};
      this.invalidTreatmentForm = false;
    }
  }

  resetDates() {
    this.removeVaccinationDate();
    this.removeNextVaccinationDate();
  }

  setWithdrawal(date) {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.withdrawal = null;
    }

    this.newTreatment.withdrawal = this.datePipe
      .transform(date, "yyyy-MM-dd")
      .replace(/\s/g, "T");
    this.datePicker2.currentDate = date;
    this.datePicker4.maxDate = date;
    this.datePicker2.currentDate_input = this.datePipe.transform(
      date,
      environment.dateFormat
    );
  }

  setWithdrawalInput() {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.withdrawal = null;
    }
    // (new Date(this.formatDate(this.datePicker2.currentDate_input))).getTime() > this.datePicker2.maxDate.getTime() ||
    // (new Date(this.formatDate(this.datePicker2.currentDate_input))).getTime() < this.datePicker2.minDate.getTime() ||
    if (
      new Date(
        this.formatDate(this.datePicker2.currentDate_input)
      ).toDateString() === "Invalid Date"
    ) {
      if (this.serverErrorValidate) {
        this.serverErrorValidate.withdrawal = "CORE.invalidDate";
      } else {
        this.serverErrorValidate = { withdrawal: "CORE.invalidDate" };
      }
      return;
    }
    this.datePicker2.currentDate = new Date(
      this.formatDate(this.datePicker2.currentDate_input)
    );
    this.newTreatment.withdrawal = this.datePipe.transform(
      this.formatDate(this.datePicker2.currentDate_input),
      "yyyy-MM-dd"
    );
    this.datePicker2.isActive = false;
  }

  setStartDate(date) {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.start_date = null;
    }
    this.newTreatment.start_date = this.datePipe
      .transform(date, "yyyy-MM-dd")
      .replace(/\s/g, "T");
    this.datePicker4.currentDate = date;
    this.datePicker2.minDate = date;
    this.datePicker4.currentDate_input = this.datePipe.transform(
      date,
      environment.dateFormat
    );
  }

  setStartDateInput() {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.start_date = null;
    }
    // (new Date(this.formatDate(this.datePicker4.currentDate_input))).getTime() > this.datePicker4.maxDate.getTime() ||
    // (new Date(this.formatDate(this.datePicker4.currentDate_input))).getTime() < this.datePicker4.minDate.getTime() ||
    if (
      new Date(
        this.formatDate(this.datePicker4.currentDate_input)
      ).toDateString() === "Invalid Date"
    ) {
      if (this.serverErrorValidate) {
        this.serverErrorValidate.start_date = "CORE.invalidDate";
      } else {
        this.serverErrorValidate = { start_date: "CORE.invalidDate" };
      }
      return;
    }
    this.datePicker4.currentDate = new Date(
      this.formatDate(this.datePicker4.currentDate_input)
    );
    this.newTreatment.start_date = this.datePipe.transform(
      this.formatDate(this.datePicker4.currentDate_input),
      "yyyy-MM-dd"
    );
    this.datePicker4.isActive = false;
  }

  /**
   * Check validity of period and disabled "Pick date" button
   * @returns {void}
   */
  checknewTreatmentValidity(): void {
    const options = { year: "numeric", month: "numeric", day: "numeric" };
    if (
      this.newTreatment.start_date &&
      this.newTreatment.withdrawal &&
      this.newTreatment.start_date > this.newTreatment.withdrawal
    ) {
      this.dateRangeTreatmentErrorMessage = {
        from: "OTHER.startDateGraterEndDate",
        due: "OTHER.startDateGraterEndDate",
      };
      this.invalidTreatmentForm = true;
    }
    // else if (new Date(this.newTreatment.start_date).getTime() < new Date(this.appMemory.user.created_at).getTime()) {
    //     this.dateRangeTreatmentErrorMessage = {
    //         from: `OTHER.dateExceededReg`,
    //         date: new Date(this.appMemory.user.created_at).toLocaleString('en-GB', options)
    //     };
    //     this.invalidTreatmentForm = true;
    // } else if (new Date(this.newTreatment.withdrawal).getTime() < new Date(this.appMemory.user.created_at).getTime()) {
    //     this.dateRangeTreatmentErrorMessage = {
    //         due: `OTHER.dateExceededReg`,
    //         date: new Date(this.appMemory.user.created_at).toLocaleString('en-GB', options)
    //     };
    //     this.invalidTreatmentForm = true;
    // }
    else {
      this.dateRangeTreatmentErrorMessage = {};
      this.invalidTreatmentForm = false;
    }
  }

  getFarmSuggestion(variant: any) {
    this._searchStream.next(variant);
  }

  uploadFilesToS3(presigned_urls: PresignedResponse[], files: any[]) {
    presigned_urls.forEach((response, index) => {
      var src = files.find((src) => src.file.name == response.filename);
      if (src) {
        this.http.put(response.url, src.file).subscribe(
          (response) => {
            console.log("response from the s3", response);
          },
          (error) => {
            console.error("Error uploading file", error);
          }
        );

        src = "";
      }
    });
  }

  uploadFileToS3(presigned_urls: PresignedResponse[], file: any) {
    this.http.put(presigned_urls[0].url, file).subscribe(
      (response) => {
        console.log("response from the s3", response);
      },
      (error) => {
        console.error("Error uploading file", error);
      }
    );
  }

  updateHorse(form: any) {
    if (form.form.invalid || !this.newHorse.gender_id) {
      return;
    }

    const ass =
      this.appMemory.user &&
      this.appMemory.user.roles &&
      this.appMemory.user.roles.length > 0 &&
      this.appMemory.user.roles[0].id === 2;
    const formData: FormData = new FormData();

    formData.append("gender_id", this.newHorse.gender_id);
    formData.append("name", this.newHorse.name);
    formData.append("birth", this.newHorse.birth);

    formData.append("hisa_id", this.newHorse.hisa_id);

    if (this.newHorse.description) {
      formData.append("description", this.newHorse.description);
    }
    formData.append("farm_id", this.newHorse.farm_id);
    formData.append("is_in_food_chain", this.newHorse.is_in_food_chain ? 1 : 0);
    formData.append("in_training", this.newHorse.in_training ? 1 : 0);
    formData.append("microchip_number", this.newHorse.microchip_number);

    var update_image = false;
    if (this.newHorse.microchip && this.isMicrochipChanged) {
      if (this.appMemory.static.appStorageType == AppStorageType.fileSystem) {
        formData.append(
          "microchip",
          this.newHorse.microchip,
          this.newHorse.microchip.name
        );
      } else {
        update_image = true;
        formData.append(
          "presigned_urls",
          JSON.stringify([
            {
              filename: this.newHorse.microchip.name,
              update_image: update_image,
            },
          ])
        );
      }
    }

    if (
      !this.newHorse.microchip &&
      this.isMicrochipChanged &&
      this.appMemory.static.appStorageType == AppStorageType.fileSystem
    ) {
      this.getService.removeMicrochip(this.horse.id, ass).then(
        (res: any) => {
          console.log("img deleted!");
        },
        (err: any) => {
          console.log("img deleting error!");
        }
      );
    }

    this.isRequestInProgress = true;

    this.getService.updateHorse(this.horse.id, formData, ass).then(
      (res: any) => {
        this.isRequestInProgress = false;
        this.isMicrochipChanged = false;

        if (
          this.newHorse.microchip &&
          res.presigned_urls &&
          res.presigned_urls.length > 0
        ) {
          this.uploadFileToS3(res.presigned_urls, this.newHorse.microchip);
          update_image = false;
        }

        this.clearUserInput(this.updateHorseForm);
        this.hideModal();
        this.getFarms();

        if (ass) {
          this.getHorseByUserRole();
        } else {
          this.getHorseDetails();
        }

        this.notificationsService.success(
          `${this.translation["editHorse"]}`,
          `${this.translation["horse"]} ${this.translation["edittedSuccess"]}`
        );

        if (this.isUkCountry) {
          if (this.currentFarm.id != this.newHorse.farm_id) {
            window.location.reload();
          }
        }
      },
      (err: any) => {
        this.isRequestInProgress = false;
        this.notificationsService.error(
          `${this.translation["editHorse"]}`,
          `${this.translation["errorOccurred"]}`
        );
        this.serverError = this.objectToArray(JSON.parse(err._body));
      }
    );
  }

  createTreatment(role: string, form: any) {
    if (
      !this.hasNoTreatment &&
      !this.isAUSCountry &&
      (form.form.invalid ||
        !this.newTreatment.drug ||
        !this.newTreatment.route ||
        !this.newTreatment.withdrawal ||
        !this.newTreatment.start_date ||
        !this.newTreatment.quantity_measure ||
        !this.newTreatment.administer ||
        (this.tabs.displayAintreeTabs && !this.newTreatment.drug_type))
    ) {
      return;
    }

    if (
      form.form.invalid ||
      (this.isAUSCountry &&
        this.newTreatment.type ==
          AUSTreatmentTypes.pre_travel_trainer_potential_long_acting &&
        (this.showOtherSubstancesInput == undefined ||
          (!this.newTreatment.other_substances &&
            this.showOtherSubstancesInput == true)))
    ) {
      return;
    }

    if (
      !this.hasNoTreatment &&
      this.isAUSCountry &&
      !this.newTreatment.withdrawal &&
      this.newTreatment.type !=
        AUSTreatmentTypes.trainer_routine_procedure_form &&
      this.newTreatment.type !=
        AUSTreatmentTypes.pre_travel_trainer_routine_procedure_form &&
      this.newTreatment.frequency_type != FrequencyType.SingleUse
    ) {
      return;
    }

    if (
      !this.newTreatment.frequency_type &&
      this.isAUSCountry &&
      !this.hasNoTreatment
    ) {
      return;
    }

    this.isRequestInProgress4 = true;

    const formData: FormData = new FormData();

    formData.append("horse_id[0]", this.horseId.toString());

    formData.append(
      "type",
      this.newTreatment.type || this.selectedTab
        ? this.newTreatment.type || this.selectedTab
        : "other"
    );

    if (this.newTreatment.drug && this.newTreatment.drug.id) {
      formData.append("drug_id", this.newTreatment.drug.id);
    }

    // if (!this.newTreatment.drug || !this.newTreatment.drug.id) {
    //   formData.append("drug_name", this.newTreatment.drug_name);
    //   formData.append("drug_brand", this.newTreatment.drug_brand);
    // }

    if (!this.newTreatment.drug || !this.newTreatment.drug.id) {
      formData.append("drug_name", this.newTreatment.drug_name || "");
    }

    formData.append("route", this.newTreatment.route || "");

    if (
      this.newTreatment.route &&
      this.newTreatment.route.toLowerCase() === RouteTypes.other
    ) {
      formData.append("other_route", this.newTreatment.other_route);
    }

    if (
      this.newTreatment.route &&
      this.newTreatment.route.toLocaleLowerCase() ===
        RouteTypes.intraArticular &&
      (this.tabs.displayAintreeTabs || this.isAUSCountry)
    ) {
      formData.append(
        "intra_articular_infoA",
        this.newTreatment.intra_articular_infoA
      );
      formData.append(
        "intra_articular_infoB",
        this.newTreatment.intra_articular_infoB
      );

      if (
        this.newTreatment.intra_articular_infoB &&
        this.newTreatment.intra_articular_infoB ===
          IntraArticularAdditionalInfoB.other
      ) {
        formData.append(
          "intra_articular_other_info",
          this.newTreatment.intra_articular_other_info
        );
      }
    }

    if (this.newTreatment.route !== RouteTypes.noTreatment) {
      if (this.isUkCountry || this.isAUSCountry) {
        formData.append("frequency_type", this.newTreatment.frequency_type);
        formData.append("frequency", this.newTreatment.frequency || "");
        formData.append(
          "procedure_type",
          this.newTreatment.procedure_type || ""
        );
      }
      formData.append("reason", this.newTreatment.reason || "");
      formData.append("start_date", this.newTreatment.start_date);
      formData.append(
        "withdrawal",
        this.newTreatment.withdrawal ? this.newTreatment.withdrawal : ""
      );
      formData.append("quantity", this.newTreatment.quantity || "");
      formData.append("other_quantity", this.newTreatment.other_quantity || "");
      formData.append(
        "quantity_measure",
        this.newTreatment.quantity_measure || ""
      );
      /*formData.append("detection_time", this.newTreatment.detection_time);*/

      if (this.tabs.displayAintreeTabs) {
        formData.append("duration", 0);
        formData.append("drug_type", this.newTreatment.drug_type);
        formData.append(
          "other_drug_type",
          this.newTreatment.other_drug_type || ""
        );
      } else if (this.isHKCountry) {
        formData.append(
          "duration",
          this.newTreatment.drug.id != 0 ? this.newTreatment.drug.duration : 0
        );
      } else {
        formData.append(
          "duration",
          this.newTreatment.duration ? this.newTreatment.duration : 0
        );
      }
    }

    if (!!this.newTreatment.administer) {
      if (this.newTreatment.administer.user_id <= 0) {
        this.newTreatment.administer.user_id = null;
      }
      Object.keys(this.newTreatment.administer).forEach((key) => {
        formData.append(
          `administer[${key}]`,
          this.newTreatment.administer[key]
        );
      });
    }

    if (
      this.newTreatment.type ==
      AUSTreatmentTypes.pre_travel_trainer_potential_long_acting
    ) {
      formData.append(
        "other_substances_checked",
        this.showOtherSubstancesInput != undefined
          ? this.showOtherSubstancesInput.toString()
          : "false"
      );
      formData.append(
        "other_substances",
        this.newTreatment.other_substances || ""
      );
    }

    if (this.triggerButton == TreatmentSaveType.Save) {
      if (this.newTreatment.src && this.isImagesChanged) {
        const imgs = $(".with_description .image-container .image");
        if (this.appMemory.static.appStorageType == AppStorageType.fileSystem) {
          this.newTreatment.src.forEach((e, i) => {
            formData.append("images[" + i + "][content]", e.file, e.file.name);
            formData.append(
              "images[" + i + "][description]",
              $(imgs[i]).find("input").val()
            );
          });
        } else {
          var presignedUrls = this.newTreatment.src.map((e, i) => ({
            horse: this.horseId.toString(),
            filename: e.file.name,
            description: $(imgs[i]).find("input").val(),
            update_image: true,
          }));

          formData.append("presigned_urls", JSON.stringify(presignedUrls));
        }
      }
    }

    switch (this.appMemory.user.roles[0].id) {
      case 1:
        this.getService.createTreatment(role, formData).then(
          (res: any) => {
            if (
              this.newTreatment.src &&
              res.presigned_urls &&
              res.presigned_urls.length > 0
            ) {
              this.uploadFilesToS3(res.presigned_urls, this.newTreatment.src);
            }
            if (this.triggerButton == TreatmentSaveType.Save) {
              this.clearUserInput(this.createTreatmentForm);
            }
            this.treatmentsByDate = [];
            this.treatmentsByDateArchive = [];
            this.isRequestInProgress4 = false;

            this.getHorse("", "", false);

            this.getHorse("/treatments", this.selectedTab);
            this.notificationsService.success(
              `${this.translation["addTreat"]}`,
              `${this.translation["treatment"]} ${this.translation["addedSuccess"]}`
            );
            if (this.triggerButton == TreatmentSaveType.Save) {
              this.hideModal();
            }
          },
          (err: any) => {
            console.log("ERR", err);
            this.isRequestInProgress4 = false;
            this.notificationsService.error(
              `${this.translation["addTreat"]}`,
              `${this.translation["errorOccurred"]}`
            );
            this.serverError = this.objectToArray(JSON.parse(err._body));
          }
        );
        break;

      case 2:
        this.getService.createTreatmentA(role, formData, [this.horse.id]).then(
          (res: any) => {
            if (
              this.newTreatment.src &&
              res.presigned_urls &&
              res.presigned_urls.length > 0
            ) {
              this.uploadFilesToS3(res.presigned_urls, this.newTreatment.src);
            }

            if (this.triggerButton == TreatmentSaveType.Save) {
              this.clearUserInput(this.createTreatmentForm);
            }

            this.treatmentsByDate = [];
            this.treatmentsByDateArchive = [];
            this.isRequestInProgress4 = false;

            this.getHorseA("", "", false);

            this.getHorse("/treatments", this.selectedTab);
            this.notificationsService.success(
              `${this.translation["addTreat"]}`,
              `${this.translation["treatment"]} ${this.translation["addedSuccess"]}`
            );
            if (this.triggerButton == TreatmentSaveType.Save) {
              this.hideModal();
            }
          },
          (err: any) => {
            this.isRequestInProgress4 = false;
            this.notificationsService.error(
              `${this.translation["addTreat"]}`,
              `${this.translation["errorOccurred"]}`
            );
            this.serverError = this.objectToArray(JSON.parse(err._body));
          }
        );
        break;

      case 3:
        this.getService
          .createTreatmentV(
            role,
            formData,
            [this.horse.id],
            this.horse.instructor_id
          )
          .then(
            (res: any) => {
              if (
                this.newTreatment.src &&
                res.presigned_urls &&
                res.presigned_urls.length > 0
              ) {
                this.uploadFilesToS3(res.presigned_urls, this.newTreatment.src);
              }

              if (this.triggerButton == TreatmentSaveType.Save) {
                this.clearUserInput(this.createTreatmentForm);
              }

              this.treatmentsByDate = [];
              this.treatmentsByDateArchive = [];
              this.isRequestInProgress4 = false;

              this.getHorseV("", "", false);

              this.getHorse("/treatments", this.selectedTab);
              this.notificationsService.success(
                `${this.translation["addTreat"]}`,
                `${this.translation["treatment"]} ${this.translation["addedSuccess"]}`
              );
              if (this.triggerButton == TreatmentSaveType.Save) {
                this.hideModal();
              }
            },
            (err: any) => {
              console.log("ERR", err);
              this.isRequestInProgress4 = false;
              this.notificationsService.error(
                `${this.translation["addTreat"]}`,
                `${this.translation["errorOccurred"]}`
              );
              this.serverError = this.objectToArray(JSON.parse(err._body));
            }
          );
        break;
    }
  }

  createQuickTreatment(role: string, form: any) {
    if (!this.newTreatment.src || !this.newTreatment.src.length) {
      return;
    }
    this.isRequestInProgress4 = true;

    const formData: FormData = new FormData();

    formData.append("horses_id[0]", this.horse.id);

    if (this.newTreatment.src && this.isImagesChanged) {
      const imgs = $(".with_description .image-container .image");
      if (this.appMemory.static.appStorageType == AppStorageType.fileSystem) {
        this.newTreatment.src.forEach((e, i) => {
          formData.append("images[" + i + "][content]", e.file, e.file.name);
          formData.append(
            "images[" + i + "][description]",
            $(imgs[i]).find("input").val()
          );
        });
      } else {
        var presignedUrls = this.newTreatment.src.map((e, i) => ({
          filename: e.file.name,
          description: $(imgs[i]).find("input").val(),
          update_image: true,
        }));

        formData.append("presigned_urls", JSON.stringify(presignedUrls));
      }
    }

    this.getService.createQuickTreatment(role, formData).then(
      (res: any) => {
        if (res.presigned_urls && res.presigned_urls.length > 0) {
          this.uploadFilesToS3(res.presigned_urls, this.newTreatment.src);
        }
        this.clearUserInput(this.createTreatmentForm);
        this.treatmentsByDate = [];
        this.treatmentsByDateArchive = [];
        this.isRequestInProgress4 = false;
        this.getHorse("/treatments");
        this.notificationsService.success(
          `${this.translation["addTreat"]}`,
          `${this.translation["treatment"]} ${this.translation["addedSuccess"]}`
        );
        this.hideModal();
      },
      (err: any) => {
        this.isRequestInProgress4 = false;
        this.notificationsService.error(
          `${this.translation["addTreat"]}`,
          `${this.translation["errorOccurred"]}`
        );
        this.serverError = this.objectToArray(JSON.parse(err._body));
      }
    );
  }

  updateTreatment(role: string, form: any) {
    if (
      !this.isAUSCountry &&
      (form.form.invalid ||
        !this.newTreatment.drug ||
        !this.newTreatment.withdrawal ||
        !this.newTreatment.start_date ||
        !this.newTreatment.quantity_measure ||
        !this.isTreatmentEditable(this.newTreatment) ||
        (this.tabs.displayAintreeTabs && !this.newTreatment.drug_type))
    ) {
      return;
    }

    this.isRequestInProgress4 = true;

    const formData: FormData = new FormData();

    formData.append("horse_id", this.horseId.toString());
    if (this.isUkCountry || this.isAUSCountry) {
      formData.append("type", this.newTreatment.type);
      formData.append("frequency", this.newTreatment.frequency);
    }

    if (this.newTreatment.drug && this.newTreatment.drug.id) {
      formData.append("drug_id", this.newTreatment.drug.id);
    }

    // if (!this.newTreatment.drug || !this.newTreatment.drug.id) {
    //   formData.append("drug_name", this.newTreatment.drug_name);
    //   formData.append("drug_brand", this.newTreatment.drug_brand);
    // }

    if (!this.newTreatment.drug || !this.newTreatment.drug.id) {
      formData.append("drug_name", this.newTreatment.drug_name || "");
    }

    if (this.tabs.displayAintreeTabs) {
      formData.append("drug_type", this.newTreatment.drug_type);
      formData.append(
        "other_drug_type",
        this.newTreatment.other_drug_type || ""
      );
    }

    formData.append("route", this.newTreatment.route || "");

    if (this.isUkCountry || this.isAUSCountry) {
      formData.append("frequency", this.newTreatment.frequency || "");
      formData.append("procedure_type", this.newTreatment.procedure_type || "");
    }

    if (
      this.newTreatment.route &&
      this.newTreatment.route.toLowerCase() === RouteTypes.other
    ) {
      formData.append("other_route", this.newTreatment.other_route);
    }

    formData.append("reason", this.newTreatment.reason || "");
    formData.append("start_date", this.newTreatment.start_date);
    formData.append(
      "withdrawal",
      this.newTreatment.withdrawal ? this.newTreatment.withdrawal : ""
    );
    formData.append("quantity", this.newTreatment.quantity || "");
    formData.append("other_quantity", this.newTreatment.other_quantity || "");
    formData.append(
      "quantity_measure",
      this.newTreatment.quantity_measure || ""
    );

    if (this.isHKCountry) {
      formData.append(
        "duration",
        this.newTreatment.drug.id != 0 ? this.newTreatment.drug.duration : 0
      );
    } else {
      formData.append(
        "duration",
        this.newTreatment.duration ? this.newTreatment.duration : 0
      );
    }

    if (
      this.newTreatment.route &&
      this.newTreatment.route.toLocaleLowerCase() ===
        RouteTypes.intraArticular &&
      (this.tabs.displayAintreeTabs || this.isAUSCountry)
    ) {
      formData.append(
        "intra_articular_infoA",
        this.newTreatment.intra_articular_infoA
      );
      formData.append(
        "intra_articular_infoB",
        this.newTreatment.intra_articular_infoB
      );

      if (
        this.newTreatment.intra_articular_infoB &&
        this.newTreatment.intra_articular_infoB ===
          IntraArticularAdditionalInfoB.other
      ) {
        formData.append(
          "intra_articular_other_info",
          this.newTreatment.intra_articular_other_info
        );
      }
    }

    if (!!this.newTreatment.administer) {
      if (this.newTreatment.administer.user_id <= 0) {
        this.newTreatment.administer.user_id = null;
      }
      Object.keys(this.newTreatment.administer).forEach((key) => {
        formData.append(
          `administer[${key}]`,
          this.newTreatment.administer[key]
        );
      });
    }

    if (this.triggerButton == TreatmentSaveType.Save) {
      if (this.newTreatment.prescriptions[0].images) {
        const del = [];
        this.newTreatment.prescriptions[0].images.forEach((el) => {
          let flag = true;
          this.newTreatment.srcs.forEach((el2) => {
            if (flag && el2.id === el.id) {
              flag = false;
            }
          });
          if (flag) {
            del.push(el.id);
          }
        });
        if (del.length > 0) {
          const requestObj = {};
          switch (role) {
            case "/vet":
              requestObj["url"] =
                "/treatment-request-vet/" + this.newTreatment.id;
              break;
            case "/assistant":
              requestObj["url"] = "/treatment-request/" + this.newTreatment.id;
              break;
            case "/instructor":
              requestObj["url"] =
                "/instructor/treatment/" + this.newTreatment.id;
              break;
          }
          requestObj["params"] = { "images[]": del };
          this.getService.removeImages(requestObj).then(
            (res) => {},
            (err) => {
              console.log(err);
            }
          );
        }
      }

      var update_image = false;
      if (this.newTreatment.src && this.isImagesChanged) {
        const imgs = $(".with_description .image-container .image");
        if (this.appMemory.static.appStorageType == AppStorageType.fileSystem) {
          this.newTreatment.src.forEach((e, i) => {
            formData.append("images[" + i + "][content]", e.file, e.file.name);
            formData.append(
              "images[" + i + "][description]",
              $(imgs[i]).find("input").val()
            );
          });
        } else {
          update_image = true;
          var presignedUrls = this.newTreatment.src.map((e, i) => ({
            filename: e.file.name,
            description: $(imgs[i]).find("input").val(),
            update_image: update_image,
          }));

          formData.append("presigned_urls", JSON.stringify(presignedUrls));
        }
      }
    }

    switch (this.appMemory.user.roles[0].id) {
      case 1:
        this.getService
          .updateTreatment(role, formData, this.newTreatment.id)
          .then(
            (res: any) => {
              if (
                this.newTreatment.src &&
                res.presigned_urls &&
                res.presigned_urls.length > 0
              ) {
                this.uploadFilesToS3(res.presigned_urls, this.newTreatment.src);
                update_image = false;
              }

              if (this.triggerButton != TreatmentSaveType.SaveAndCopy) {
                this.clearUserInput(this.updateTreatmentForm);
              }

              this.getHorseByUserRole({
                excludeHorse: true,
                excludeTreatments: false,
                excludeNotes: true,
                excludeVaccination: true,
              });
              this.isRequestInProgress4 = false;
              this.notificationsService.success(
                `${this.translation["editTreat"]}`,
                `${this.translation["treatment"]} ${this.translation["edittedSuccess"]}`
              );
              this.hideModal();
              if (this.triggerButton == TreatmentSaveType.SaveAndCopy) {
                this.openAddTreatment();
              }
            },
            (err: any) => {
              this.isRequestInProgress4 = false;
              this.notificationsService.error(
                `${this.translation["editTreat"]}`,
                `${this.translation["errorOccurred"]}`
              );
              this.serverError = this.objectToArray(JSON.parse(err._body));
            }
          );
        break;

      case 2:
        this.getService
          .updateTreatmentA(role, formData, this.newTreatment.id)
          .then(
            (res: any) => {
              if (
                this.newTreatment.src &&
                res.presigned_urls &&
                res.presigned_urls.length > 0
              ) {
                this.uploadFilesToS3(res.presigned_urls, this.newTreatment.src);
                update_image = false;
              }

              if (this.triggerButton != TreatmentSaveType.SaveAndCopy) {
                this.clearUserInput(this.updateTreatmentForm);
              }

              this.getHorseByUserRole({
                excludeHorse: true,
                excludeTreatments: false,
                excludeNotes: true,
                excludeVaccination: true,
              });
              this.isRequestInProgress4 = false;
              this.notificationsService.success(
                `${this.translation["editTreat"]}`,
                `${this.translation["treatment"]} ${this.translation["edittedSuccess"]}`
              );
              this.hideModal();
              if (this.triggerButton == TreatmentSaveType.SaveAndCopy) {
                this.openAddTreatment();
              }
            },
            (err: any) => {
              this.isRequestInProgress4 = false;
              this.notificationsService.error(
                `${this.translation["editTreat"]}`,
                `${this.translation["errorOccurred"]}`
              );
              this.serverError = this.objectToArray(JSON.parse(err._body));
            }
          );
        break;

      case 3:
        this.getService
          .updateTreatmentV(role, formData, this.newTreatment.id)
          .then(
            (res: any) => {
              if (
                this.newTreatment.src &&
                res.presigned_urls &&
                res.presigned_urls.length > 0
              ) {
                this.uploadFilesToS3(res.presigned_urls, this.newTreatment.src);
                update_image = false;
              }

              if (this.triggerButton != TreatmentSaveType.SaveAndCopy) {
                this.clearUserInput(this.updateTreatmentForm);
              }

              this.getHorseByUserRole({
                excludeHorse: true,
                excludeTreatments: false,
                excludeNotes: true,
                excludeVaccination: true,
              });
              this.isRequestInProgress4 = false;
              this.notificationsService.success(
                `${this.translation["editTreat"]}`,
                `${this.translation["treatment"]} ${this.translation["edittedSuccess"]}`
              );

              this.hideModal();
              if (this.triggerButton == TreatmentSaveType.SaveAndCopy) {
                this.openAddTreatment();
              }
            },
            (err: any) => {
              this.isRequestInProgress4 = false;
              this.notificationsService.error(
                `${this.translation["editTreat"]}`,
                `${this.translation["errorOccurred"]}`
              );
              this.serverError = this.objectToArray(JSON.parse(err._body));
            }
          );
        break;
    }
  }

  openAddTreatment() {
    $("body").addClass("modal-open");
    $("#add-treatment").fadeIn(400).addClass("open");
    return false;
  }

  proceessTreatment(treatment: Treatment, form?: any) {
    if (form && form.form.invalid) {
      return;
    }

    if (!this.treatmentStatus.comment) {
      this.treatmentStatus.comment = undefined;
    }

    switch (this.treatmentStatus.status) {
      case "approved":
        this.treatmentStatus.comment = undefined;
        this.treatmentStatus.vetclinic_id = 1;
        break;

      case "cancelled":
        this.treatmentStatus.vetclinic_id = undefined;
        break;
    }

    this.getService
      .proceessTreatment(this.treatmentStatus.request_id, this.treatmentStatus)
      .then(
        (res: any) => {
          if (form) {
            this.clearUserInput(form);
          }

          this.hideModal();
          this.getHorseByUserRole({
            excludeHorse: true,
            excludeTreatments: false,
            excludeNotes: true,
            excludeVaccination: true,
          });
          this.notificationsService.success(
            `${this.translation["updateTreatmentStatus"]}`,
            `${this.translation["treatmentStatus"]} ${this.translation["updatedSuccess"]}`
          );
        },
        (err: any) => {
          // console.log('ERR', err);
          this.isRequestInProgress = false;
          this.notificationsService.error(
            `${this.translation["updateTreatmentStatus"]}`,
            `${this.translation["errorOccurred"]}`
          );
          this.serverError = this.objectToArray(JSON.parse(err._body));
        }
      );
  }

  changeTreatmentStatus(id: number, body: any) {
    this.getService.changeTreatmentStatus(id, body).then(
      (res: any) => {
        this.hideModal();
        this.getHorseByUserRole();
        this.notificationsService.success(
          `${this.translation["closeTreatment"]}`,
          `${this.translation["archivedSuccess"]}`
        );
      },
      (err: any) => {
        console.log("ERR", err);
        this.isRequestInProgress = false;
        this.notificationsService.error(
          `${this.translation["closeTreatment"]}`,
          `${this.translation["errorOccurred"]}`
        );
        this.serverError = this.objectToArray(JSON.parse(err._body));
      }
    );
  }

  cloneTreatment(treatment: Treatment, fromCopyAction: boolean = false) {
    this.newTreatment = Object.assign({}, treatment);
    this.hasNoTreatment = this.newTreatment.route === RouteTypes.noTreatment;
    this.serverErrorValidate = null;

    if (fromCopyAction) {
      this.newTreatment.id = 0;
    }

    this.datePicker4.currentDate_input = this.datePipe.transform(
      this.newTreatment.start_date,
      environment.dateFormat
    );
    this.datePicker4.currentDate = new Date(this.newTreatment.start_date);

    this.datePicker2.currentDate_input = this.datePipe.transform(
      this.newTreatment.withdrawal,
      environment.dateFormat
    );
    this.datePicker2.currentDate = new Date(this.newTreatment.withdrawal);
    if (
      this.newTreatment.prescriptions &&
      this.newTreatment.prescriptions[0].drugs[0]
    ) {
      this.newTreatment.drug = this.newTreatment.prescriptions[0].drugs[0];
    } else {
      this.newTreatment.drug = {
        // 'brand': '',
        created_at: null,
        id: 0,
        name: "Other",
        updated_at: null,
      };
    }

    this.newTreatment.other_quantity =
      this.newTreatment.prescriptions[0].other_quantity || "";
    this.newTreatment.quantity = this.newTreatment.prescriptions[0].quantity;
    this.newTreatment.quantity_measure =
      this.newTreatment.prescriptions[0].quantity_measure;
    this.newTreatment.duration = this.newTreatment.prescriptions[0].duration;
    this.newTreatment.srcs = [];

    if (fromCopyAction == false) {
      this.newTreatment.prescriptions[0].images.forEach((el) => {
        this.newTreatment.srcs.push(Object.assign({}, el));
      });

      if (
        this.newTreatment.srcs &&
        this.appMemory.static.appStorageType == AppStorageType.s3
      ) {
        var paths = this.newTreatment.srcs.map((asset) => asset.src);
        this.getPresignedUrls(paths, "treatments");
      }
    }

    const items = this.appMemory.measures;
    const quantity = this.newTreatment.quantity_measure;
    const drugType = this.newTreatment.drug_type;
    const drugTypes = this.appMemory.drugTypes;

    this.administer = this.administers.filter(
      ({ id }) =>
        (this.newTreatment.administer &&
          id == this.newTreatment.administer.user_id) ||
        id <= 0
    );

    this.newTreatment.administer = new TreatmentAdminister(
      (treatment.administer && {
        user_id:
          treatment.administer.user_id == null || undefined
            ? -1
            : treatment.administer.user_id,
        contact_name: treatment.administer.contact_name,
        contact_info: treatment.administer.contact_info,
      }) ||
        {}
    );

    if (this.isEmpty(this.newTreatment.administer)) {
      this.newTreatment.administer.user_id = this.administer[0].id;
    }

    this.measuresSelectorModel = [
      items.find(function (obj) {
        return obj.text === quantity;
      }),
    ];

    this.drugTypesSelectorModel = [
      drugTypes.find(function (obj) {
        return obj.text === drugType;
      }),
    ];

    this.calcMaxLength(this.newTreatment.quantity);
  }

  isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  normalizeNote(note) {
    const result = Object.assign({}, note);
    const comments = (result.info || ({} as NoteInfo)).comments || {};

    Object.keys(comments || {}).forEach((k) => {
      result["comments[" + k + "]"] = comments[k];
    });

    return result;
  }

  setNote(note) {
    this.hideModal();

    this.newNote = Object.assign({}, note);
    const comments = (note.info || ({} as NoteInfo)).comments || {};

    Object.keys(comments || {}).forEach((k) => {
      this.newNote["comments[" + k + "]"] = comments[k];
    });

    if (!this.newNote.weight) {
      delete this.newNote.weight;
    }

    this.newNote.srcs = [];

    note.images.forEach((el) => {
      this.newNote.srcs.push(Object.assign({}, el));
    });

    if (
      this.newNote.srcs &&
      this.appMemory.static.appStorageType == AppStorageType.s3
    ) {
      var paths = this.newNote.srcs.map((asset) => asset.src);
      this.getPresignedUrls(paths, "notes");
    }

    this.datePickerAddNote.currentDate = this.newNote.date
      ? new Date(this.newNote.date)
      : new Date();
    this.datePickerAddNote.currentDate_input = this.datePipe.transform(
      this.newNote.date,
      environment.dateFormat
    );

    if (this.newNote.weight) {
      const items = this.appMemory.weights;
      const weight = this.newNote.weight;

      this.weightsSelectorModel = [
        items.find(function (obj) {
          return obj.text === weight;
        }),
      ];
    }
  }

  createFinalVaccination() {
    if (!this.isUSCountry) {
      this.newVaccination.vaccination_countries = [
        ...this.vaccinationCountries,
      ].filter((country) => country !== this.currentCountry);
    }

    this.getService.addVaccination(this.horseId, this.newVaccination).then(
      (res: any) => {
        $("#assistant-invite-email-box").removeClass("input--filled");
        this.clearUserInput();
        this.hideModal();
        this.vaccinations = [];
        this.getHorseByUserRole({
          excludeVaccination: false,
          excludeHorse: true,
          excludeTreatments: true,
          excludeNotes: true,
        });
        this.isRequestInProgress = false;
        this.notificationsService.success(
          `${this.translation["addVacs"]}`,
          `${this.translation["vacc"]} ${this.translation["addedSuccess"]}`
        );
      },
      (err: any) => {
        console.log("ERR", err);
        if (JSON.parse(err._body).error === "isBoosterOutsideOfDates") {
          document.getElementById("modal-vaccination-link").click();
        } else {
          this.isRequestInProgress = false;

          if (err.status === 422) {
            this.notificationsService.error(
              `${this.translation["addVacs"]}`,
              JSON.parse(err._body).error
                ? JSON.parse(err._body).error
                : `${this.translation["errorOccurred"]}`
            );

            return;
          }

          this.notificationsService.error(
            `${this.translation["addVacs"]}`,
            `${this.translation["errorOccurred"]}`
          );
        }
      }
    );
  }

  switchFromBoosterToPrimary() {
    this.newVaccination.number = "primary";
    this.createFinalVaccination();
  }

  reasignHorse() {
    this.newHorse = Object.assign({}, this.horse);
    this.farmSelectModelLoaded = false;

    this.farmSelectModel[0]["id"] = this.newHorse.farm.id;
    this.farmSelectModel[0]["text"] = this.newHorse.farm.name;

    this.farmSelectModelLoaded = true;

    setTimeout(() => {
      if (this.horse.microchip) {
        this.imageLoader.files[0] = new File([""], "microchip");
        this.imageLoader.files[0].src = this.horse.microchip;
        this.imageLoader.fileChange(this.imageLoader.files[0]);
        this.imageLoader.fileCounter = 1;
      }
    });

    this.updateHorseForm._submitted = false;
  }

  getVaccinations() {
    this.isRequestInProgress5 = true;
    this.getService.getVaccinations(this.horseId).then(
      (res: any) => {
        this.vaccinations = res.data;

        if (res.next_page_url) {
          this.paginationVc.nextPage = res.next_page_url;
        } else {
          this.paginationVc.nextPage = res.next_page_url;
        }

        this.isRequestInProgress5 = false;
      },
      (err: any) => {
        console.log("ERR", err);
        this.isRequestInProgress5 = false;
      }
    );
  }

  createVaccination(form: any) {
    if (
      form.form.invalid ||
      !this.newVaccination.date ||
      (!this.newVaccination.other && !this.newVaccination.number) ||
      (this.newVaccination.other &&
        ((this.newVaccination.other && !this.newVaccination.immunization) ||
          !this.newVaccination.name))
    ) {
      this.invalidVaccinationForm = true;
      return;
    }
    this.newVaccination.vaccination_countries = [...this.vaccinationCountries];

    this.isRequestInProgress = true;

    // const body = Object.assign({}, this.newVaccination);
    this.createFinalVaccination();
  }

  removeVaccination(form: any) {
    this.isRequestInProgress = true;

    this.getService
      .removeVaccination(this.horseId, this.currentVaccination.id)
      .then(
        (res: any) => {
          $("#assistant-invite-email-box").removeClass("input--filled");
          this.clearUserInput(form);
          this.hideModal();
          this.vaccinations = [];
          this.getHorseByUserRole({
            excludeHorse: true,
            excludeTreatments: true,
            excludeNotes: true,
            excludeVaccination: false,
          });
          this.isRequestInProgress = false;
          this.notificationsService.success(
            `${this.translation["delectVacc"]}`,
            `${this.translation["vacc"]} ${this.translation["deletedSuccess"]}`
          );
        },
        (err: any) => {
          console.log("ERR", err);
          this.isRequestInProgress = false;
          this.notificationsService.error(
            `${this.translation["delectVacc"]}`,
            `${this.translation["errorOccurred"]}`
          );
        }
      );
  }

  archiveHorse(form: any) {
    this.isRequestInProgress = true;

    this.getService.archiveHorse(this.horseId).then(
      (res: any) => {
        $("#assistant-invite-email-box").removeClass("input--filled");
        this.clearUserInput(form);
        this.hideModal();
        this.vaccinations = [];
        this.getHorseByUserRole();
        this.isRequestInProgress = false;
        this.notificationsService.success(
          `${this.translation["archiveHorse"]}`,
          `${this.translation["horse"]} archived successfully`
        );
      },
      (err: any) => {
        console.log("ERR", err);
        this.isRequestInProgress = false;
        this.notificationsService.error(
          `${this.translation["archiveHorse"]}`,
          `${this.translation["errorOccurred"]}`
        );
      }
    );
  }

  deleteTreatment(form: any) {
    this.isRequestInProgress = true;

    const role = this.appMemory.roles[this.appMemory.user.roles[0].id];

    this.getService
      .deleteTreatment(
        this.currentTreatment ? this.currentTreatment.id : this.newTreatment.id,
        role
      )
      .then(
        (res: any) => {
          this.clearUserInput(form);
          this.hideModal();
          this.getHorseByUserRole({
            excludeHorse: true,
            excludeTreatments: false,
            excludeNotes: true,
            excludeVaccination: true,
          });
          this.isRequestInProgress = false;
          this.notificationsService.success(
            `${this.translation["deleteTreat"]}`,
            `${this.translation["treatment"]} ${this.translation["deletedSuccess"]}`
          );
        },
        (err: any) => {
          console.log("ERR", err);
          this.isRequestInProgress = false;

          if (err.status === 404) {
            this.clearUserInput(form);
            this.hideModal();
            this.getHorseByUserRole({
              excludeHorse: true,
              excludeTreatments: false,
              excludeNotes: true,
              excludeVaccination: true,
            });

            this.notificationsService.error(
              `${this.translation["deleteTreat"]}`,
              `${this.translation["treatment"]} ${this.translation["wasAlreadyDeleted"]}`
            );

            return;
          }

          this.notificationsService.error(
            `${this.translation["deleteTreat"]}`,
            `${this.translation["errorOccurred"]}`
          );
        }
      );
  }

  deleteNote(form?: any) {
    this.isRequestInProgress = true;

    const role = this.appMemory.roles[this.appMemory.user.roles[0].id];

    this.getService.deleteNote(this.horseId, this.newNote.id, role).then(
      (res: any) => {
        this.clearUserInput();
        this.hideModal();
        this.getHorseByUserRole({
          excludeHorse: true,
          excludeTreatments: true,
          excludeNotes: false,
          excludeVaccination: true,
        });
        this.isRequestInProgress = false;
        this.notificationsService.success(
          `${this.translation["deleteNote"]}`,
          `${this.translation["note"]} ${this.translation["deletedSuccess"]}`
        );
      },
      (err: any) => {
        console.log("ERR", err);
        this.isRequestInProgress = false;

        if (err.status === 404) {
          this.clearUserInput();
          this.hideModal();
          this.getHorseByUserRole();

          this.notificationsService.error(
            `${this.translation["deleteNote"]}`,
            `${this.translation["note"]} ${this.translation["wasAlreadyDeleted"]}`
          );

          return;
        }

        this.notificationsService.error(
          `${this.translation["deleteTreat"]}`,
          `${this.translation["errorOccurred"]}`
        );
      }
    );
  }

  pad(num, size) {
    try {
      let s = num + "";
      while (s.length < size) {
        s = "0" + s;
      }
      return s;
    } catch (e) {
      return num;
    }
  }

  public isTreatmentEditable(treatment: Treatment): boolean {
    if (
      !treatment ||
      !treatment.horse ||
      !treatment.horse.is_active ||
      treatment.status === "closed" ||
      !this.appMemory.user ||
      (this.appMemory.user.roles as any).length === 0
    ) {
      return false;
    }
    switch (this.appMemory.user.roles[0].id) {
      case 1: // instrucotr / trainer
        if (environment.disableTreatmentEditInstructorNotOwned) {
          if (treatment.request) {
            return this.appMemory.user.id === treatment.request.user_id;
          } else {
            return true;
          }
        } else {
          return true;
        }
      case 2: //asistant
      case 3: // vet
        if (treatment.request && treatment.request.status === "approved") {
          return false;
        }
        if (treatment.request) {
          return this.appMemory.user.id === treatment.request.user_id;
        }
    }
    return false;
  }

  setToggleLabel(tabType: string) {
    switch (tabType) {
      case AUSTreatmentTypes.trainer_potential_long_acting_mdf:
        this.toggleLabel = "No long-acting medication has been administered";
        break;
      case AUSTreatmentTypes.trainer_routine_procedure_form:
        this.toggleLabel = "No procedures to declare";
        break;
      case AUSTreatmentTypes.trainer_routine_mdf:
        this.toggleLabel = "No medications has been administered";
        break;
      case AUSTreatmentTypes.pre_travel_trainer_potential_long_acting:
        this.toggleLabel = "No long-acting medication has been administered";
        break;
      case AUSTreatmentTypes.pre_travel_trainer_routine:
        this.toggleLabel = "No medications has been administered";
        break;
      case AUSTreatmentTypes.pre_travel_trainer_routine_procedure_form:
        this.toggleLabel = "No procedures to declare";
        break;
      default:
        this.toggleLabel = "No medications to declare";
        break;
    }
  }

  setTab(tab: NoteTab | TreatmentTab, type: string = "treatment") {
    let excludeTreatments;
    let excludeNotes;
    let excludeVaccination = false;

    if (this.isAUSCountry) {
      this.hideAddBtn = this.shouldHideAddBtn(tab.type);
      excludeVaccination = true;
    }

    this.hasNoTreatment = false;

    this.setToggleLabel(tab.type);

    if (type === "treatment") {
      this.tabs.isNotes = false;
      excludeNotes = true;
      excludeTreatments = false;
      this.tabs.isTreatments = true;
    }

    if (type === "note") {
      this.tabs.isTreatments = false;
      excludeTreatments = true;
      excludeNotes = false;
      this.tabs.isNotes = true;
      this.newNote.type = tab.type;
    }

    if (type === "video-submission") {
      this.tabs.isTreatments = false;
      excludeTreatments = true;
      excludeNotes = false;
      this.tabs.isNotes = true;
      this.newNote.type = tab.type;
    }

    if (this.selectedTab !== tab.type) {
      this.selectedTab = tab.type;
      this.newTreatment.type = tab.type;
      this.getHorseByUserRole({
        excludeHorse: true,
        excludeTreatments,
        excludeNotes,
        excludeVaccination,
      });
    }
  }

  setHKNoteTypes(tab: NoteTab) {
    switch (tab.type) {
      case NoteType.mdf1A_mdf1B_declaration:
        this.noteTypes = [
          {
            type: NoteType.mdf1A_mdf1B_declaration,
          },
        ];
        break;
      case NoteType.mdf2_declaration:
        this.noteTypes = [
          {
            type: NoteType.mdf2_declaration,
          },
        ];
        break;
      case NoteType.mdf3_declaration:
        this.noteTypes = [
          {
            type: NoteType.mdf3_declaration,
          },
        ];
        break;
      case NoteType.preTravel_vet_form:
        this.noteTypes = [
          {
            type: NoteType.preTravel_vet_form,
          },
        ];
        break;

      case NoteType.hongkongHealthCertificate:
        this.noteTypes = [
          {
            type: NoteType.hongkongHealthCertificate,
          },
        ];
        break;
    }
  }

  public setCurrentTreatment(treatment) {
    this.currentTreatment = treatment;
    this.hasNoTreatment = treatment.route === RouteTypes.noTreatment;

    this.newTreatment.srcs = [];

    treatment.prescriptions[0].images.forEach((el) => {
      this.newTreatment.srcs.push(Object.assign({}, el));
    });

    if (
      this.newTreatment.srcs &&
      this.appMemory.static.appStorageType == AppStorageType.s3
    ) {
      var paths = this.newTreatment.srcs.map((asset) => asset.src);
      this.getPresignedUrls(paths, "treatments");
    }
  }

  generateNoteFields(selectedType?: string): NoteFormField[] {
    if (this.isUSCountry) {
      const [{ form = [] } = {}] = this.noteTypesList.filter(
        ({ type }) =>
          type === (selectedType || (this.hasSignNoteType && NoteType.sign))
      );
      return form;
    }

    if (this.isHKCountry) {
      const [{ form = [] } = {}] = this.noteTypesList.filter(
        ({ type }) => type === selectedType
      );
      return form;
    }

    if (
      this.selectedTab == "vet_form_stage1" ||
      this.selectedTab == "vet_form_stage2" ||
      this.selectedTab == "trainer_declaration_form"
    ) {
      const [{ form = [] } = {}] = this.aintreeNoteTypes.filter(
        ({ type }) => type === (selectedType || this.selectedTab)
      );

      return form;
    }

    if (this.isAUSCountry) {
      if (this.tabs.isPreTravelTab) {
        const [{ form = [] } = {}] = this.ausPreTravelNoteTypes.filter(
          ({ type }) => type === (selectedType || this.selectedTab)
        );

        return form;
      }
      const [{ form = [] } = {}] = this.ausNoteTypes.filter(
        ({ type }) => type === (selectedType || this.selectedTab)
      );

      return form;
    }
  }

  setTreatmentAdminister(e) {
    this.administer = [e];
    const administer = this.administers.filter(({ id }) => id == e.id).shift();
    this.newTreatment.administer = new TreatmentAdminister(
      (!!administer && {
        user_id: administer.id,
      }) ||
        {}
    );
  }

  goToLink() {
    let url = `${environment.vaccinationDocumentUrl}/${this.horse.external_reference}/${this.horse.token}`;
    window.open(url, "_blank");
  }

  getTreatmentAdministers(horseId?: number) {
    horseId =
      (!!horseId && horseId) || this.activatedRoute.params["value"]["horse_id"];
    this.getService
      .getHorse(horseId, "/administers")
      .then((res: User[]) => {
        this.administers = res
          .map((adm) => {
            return new Administer({
              id: adm.id,
              text: `${adm.name} ${adm.last_name}`,
            });
          })
          .concat(
            new Administer({
              id: -1,
              text: "Other",
            })
          );
      })
      .catch((e) => (this.administers = []));
  }

  sortNoteBy(field: string, sortColumn?: string) {
    this.sortNoteObj.order =
      this.sortNoteObj.field === field
        ? this.sortNoteObj.order === "desc"
          ? "asc"
          : "desc"
        : "desc";
    this.sortNoteObj.field = field;

    this.getHorseByUserRole({
      excludeHorse: true,
      excludeTreatments: true,
      excludeNotes: false,
    });
  }

  sortTreatmentBy(field: string, sortColumn: string) {
    this.sortTreatmentObj.order =
      this.sortTreatmentObj.field === field
        ? this.sortTreatmentObj.order === "desc"
          ? "asc"
          : "desc"
        : "desc";
    this.sortTreatmentObj.field = field;

    this.getHorseByUserRole({
      excludeHorse: true,
      excludeTreatments: false,
      excludeNotes: true,
    });
  }

  setTriggerButton(type: TreatmentSaveType) {
    this.triggerButton = type;
  }

  checkHorseIsBC2023Region() {
    if (this.farms && this.farms.length > 0) {
      const selectedFarm = this.farms.find(
        (farm) => farm.id == this.newHorse.farm_id
      );

      return selectedFarm && selectedFarm.region == usaRegionBC2023;
    }
  }

  conditionalClick(type: string) {
    if (type != NoteType.attendingVetForm) {
      this.newNote.type = type;
    }
  }

  checkNoteType(type: string) {
    if (type == NoteType.attendingVetForm) {
      return true;
    }

    return false;
  }

  onTypeSelected(selectedType: { type: string; toggleLabel: string }) {
    this.toggleLabel = selectedType.toggleLabel;
    this.hasNoTreatment = false;
    this.showOtherSubstancesInput = undefined;
    this.selectedTab = selectedType.type;

    this.getHorse("/treatments", this.selectedTab);
  }

  setProcedureValue(e: any) {
    this.newTreatment.procedure_type = e.id;
  }

  getActiveProcedure() {
    if (this.newTreatment.procedure_type) {
      var selectedItem = [
        {
          id: this.newTreatment.procedure_type,
          text: this.newTreatment.procedure_type,
        },
      ];
      return selectedItem;
    }
    return [];
  }

  setIsFormInViewMode() {
    if (this.isAUSCountry) {
      this.isFormInViewMode = !this.isFormInViewMode;
    }
  }

  handleAusRVTabTypeSelected() {
    this.selectedTab = "";
    // EMR-641: after switching RV parent tab, auto-select its first form.
    // Deferred so the tabset's select/deselect events settle the
    // isPreTravelTab / isPreRaceTab flags before we read them.
    setTimeout(() => this.selectFirstAusRvForm());
  }

  onOtherSubstanceChange(value: boolean) {
    this.showOtherSubstancesInput = value;

    if (!value) {
      this.newTreatment.other_substances = "";
    }
  }

  getDrugsList() {
    if (this.isAUSCountry) {
      debugger;
      if (
        this.selectedTab ==
          AUSTreatmentTypes.pre_travel_trainer_potential_long_acting ||
        this.selectedTab == AUSTreatmentTypes.trainer_potential_long_acting_mdf
      ) {
        this.drugList = this.longActingDrugs;
      } else if (
        this.selectedTab == AUSTreatmentTypes.pre_travel_trainer_routine ||
        this.selectedTab == AUSTreatmentTypes.trainer_routine_mdf
      ) {
        this.drugList = this.routineDrugs;
      }
    } else {
      this.drugList = this.drugs;
    }

    return this.drugList;
  }

  confirmAndOpenTreatmentModal(modelId: string) {
    if (!this.isAUSCountry) {
      return;
    }

    if (
      this.isAUSCountry &&
      this.treatmentsByDate.find(
        (tr) => tr.target_race_id == this.horse.target_race_id
      ) !== undefined
    ) {
      const userConfirmed = confirm(
        "You have already completed this form. Are you sure you want to add another?"
      );
      if (userConfirmed) {
        this.openModelById(modelId);
      }
    } else {
      this.openModelById(modelId);
    }
  }

  confirmAndOpenNoteModal(modelId: string) {
    if (!this.isAUSCountry) {
      return;
    }

    if (
      this.isAUSCountry &&
      this.notes.find((nt) => nt.target_race_id == this.horse.target_race_id)
    ) {
      const userConfirmed = confirm(
        "You have already completed this form. Are you sure you want to add another?"
      );
      if (userConfirmed) {
        this.openModelById(modelId);
      }
    } else {
      this.openModelById(modelId);
    }
  }

  openModelById(modelId: string) {
    if (!modelId) {
      return;
    }

    $("body").addClass("modal-open");

    var idForm = $(`#${modelId}`);
    $(idForm).fadeIn(400).addClass("open");
  }

  shouldHideAddBtn(type: string) {
    if (
      this.isAUSCountry &&
      this.horse.races.find((race) => race.id == this.horse.target_race_id) &&
      this.horse.races.find((race) => race.id == this.horse.target_race_id)
        .pivot.is_eligible
    ) {
      return true;
    }

    if (
      this.isAUSCountry &&
      this.tabs.isPreTravelTab &&
      this.horse.is_preTravel_forms_completed
    ) {
      return true;
    }

    if (
      this.isAUSCountry &&
      this.tabs.isPreRaceTab &&
      !this.horse.is_preTravel_forms_completed
    ) {
      return true;
    }

    if (this.appMemory.user.roles[0].id != 3) {
      if (
        this.isAUSCountry &&
        this.horse.next_to_submit != type &&
        !this.horse.submitted_treatment_types.includes(type) &&
        !this.horse.submitted_notes_types.includes(type)
      ) {
        return true;
      }
    }

    return false;
  }

  getNoteModelSubmitButtonText(): string {
    if (
      !this.tabs.displayAintreeTabs &&
      !this.isHKCountry &&
      !this.isAUSCountry
    ) {
      return "HORSES.addNote";
    } else if (this.isHKCountry) {
      return "HORSES.addDeclaration";
    } else if (
      (this.isAUSCountry &&
        this.newNote.type ===
          NoteType.aus_rv_veterinary_declaration_execution_submission_form) ||
      this.newNote.type ===
        NoteType.trainer_declaration_execution_submission_form ||
      this.newNote.type === NoteType.aus_rv_declarations_excecution ||
      this.newNote.type ===
        NoteType.veterinary_declaration_execution_submission_form
    ) {
      return "HORSES.save_submit";
    } else if (
      this.appMemory.user &&
      this.appMemory.user.roles[0].id == 3 &&
      this.tabs.isPreTravelTab &&
      this.isAUSCountry
    ) {
      return "HORSES.saveForm";
    } else {
      return "HORSES.addForm";
    }
  }

  isFormAlreadyEligible() {
    if (
      this.eligible_forms &&
      this.selectedTab &&
      this.eligible_forms[this.selectedTab] &&
      this.isHKCountry
    ) {
      return true;
    }
    return false;
  }

  isFormAlreadyEligibleCheckByType(formType: string) {
    if (
      this.eligible_forms &&
      this.eligible_forms[formType] &&
      this.isHKCountry
    ) {
      return true;
    }
    return false;
  }

  addNewMedication() {
    if (this.newMedication.trim()) {
      this.isRequestInProgress = true;
      this.getService.requestNewMedication(this.newMedication).then((res) => {
        if (res.success) {
          this.newMedication = "";
          this.isRequestInProgress = false;
          this.notificationsService.success("Request Medication", res.message);
        } else {
          this.isRequestInProgress = false;
          this.notificationsService.error(
            "Request Medication",
            "Error while request new medication"
          );
        }
      });
    }
  }

  isHorseEligibleForTargetRace(horse: Horse) {
    return (
      this.horse.races.find((race) => race.id == this.horse.target_race_id) &&
      this.horse.races.find((race) => race.id == this.horse.target_race_id)
        .pivot.is_eligible
    );
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/horse/horse.component.ts